export default {
  "ApiErrorCode.40001001": "验证码错误",
  "ApiErrorCode.40001004": "不允许禁用，该用户是组织下的根用户",
  "ApiErrorCode.40001005": "无法通过邮箱地址提取用户信息",
  "ApiErrorCode.101101001": "组织不存在",
  "ApiErrorCode.101101002": "组织名称已经存在",
  "ApiErrorCode.101101003": "创建组织失败, 请重试",
  "ApiErrorCode.101101004": "重置appSecret失败，请重试",
  "ApiErrorCode.101101005": "创建组织失败，请重试",
  "ApiErrorCode.101101006": "创建组织失败，请重试",
  "ApiErrorCode.101101008": "租户邮件已经存在",
  "ApiErrorCode.101101009": "组织激活失败，请重试",
  "ApiErrorCode.101101010": "组织禁用失败，请重试",
  "ApiErrorCode.101101011": "重新发送激活邮件失败，请重试",
  "ApiErrorCode.101101012": "操作过于频繁，请重试",
  "ApiErrorCode.101101015": "更新租户失败",
  "ApiErrorCode.101101016": "组织已激活",
  "ApiErrorCode.101101017": "组织尚未激活",
  "ApiErrorCode.101101018": "组织已启用",
  "ApiErrorCode.101101019": "组织已禁用",
  "ApiErrorCode.101101020": "组织合同续期失败",
  "ApiErrorCode.101102001": "用户不存在",
  "ApiErrorCode.101102002": "用户已存在",
  "ApiErrorCode.101102003": "用户账户被禁用",
  "ApiErrorCode.101102004": "重置链接已失效",
  "ApiErrorCode.101102005": "激活链接已失效",
  "ApiErrorCode.101102006": "操作失败，请稍后重试",
  "ApiErrorCode.101102007": "邮件不能为空",
  "ApiErrorCode.101102008": "链接已失效",
  "ApiErrorCode.101102009": "用户信息不匹配",
  "ApiErrorCode.101102010": "无操作权限",
  "ApiErrorCode.101102011": "超级管理员不能被编辑",
  "ApiErrorCode.101102012": "更新失败",
  "ApiErrorCode.101102013": "操作失败，请稍后重试",
  "ApiErrorCode.101102014": "不允许通过接口创建超级管理员",
  "ApiErrorCode.101102016": "内部管理系统用户已激活",
  "ApiErrorCode.101103001": "账户不存在",
  "ApiErrorCode.101103002": "更新账户密码失败",
  "ApiErrorCode.101105001": "发送邮件异常，请稍后重试",
  "ApiErrorCode.101105002": "发送邮件异常，请稍后重试",
  "ApiErrorCode.101105003": "邮件验证码错误",
  "ApiErrorCode.101109001": "创建公告时出错，请检查输入的参数",
  "ApiErrorCode.101109002": "公告结束时间必须比开始时间、当前时间大",
  "ApiErrorCode.202101001": "用户不存在",
  "ApiErrorCode.202101002": "用户已存在",
  "ApiErrorCode.202101004": "MFA解密失败",
  "ApiErrorCode.202101005": "MFA加密失败",
  "ApiErrorCode.202101007": "MFA SharedSecret 丢失",
  "ApiErrorCode.202101008": "绑定MFA失败，请稍后重试",
  "ApiErrorCode.202101009": "MFA安全代码错误",
  "ApiErrorCode.202101010": "MFA安全代码错误",
  "ApiErrorCode.202101011": "MFA安全代码错误",
  "ApiErrorCode.202101012": "手机号已存在",
  "ApiErrorCode.202101014": "手机号已存在",
  "ApiErrorCode.202101015": "当前账号没有绑定任何组织",
  "ApiErrorCode.202101017": "操作超时，请稍后重试",
  "ApiErrorCode.202101018": "组织已禁用",
  "ApiErrorCode.202102001": "用户创建失败，请联系管理员",
  "ApiErrorCode.202102002": "用户已存在",
  "ApiErrorCode.202102003": "超级管理员不能被编辑",
  "ApiErrorCode.202102004": "不允许通过员工api更新为超级管理员",
  "ApiErrorCode.202103001": "角色不存在",
  "ApiErrorCode.202103002": "角色名称已经存在",
  "ApiErrorCode.202103003": "角色创建失败",
  "ApiErrorCode.202103004": "角色更新失败",
  "ApiErrorCode.202103005": "存在不允许分配的权限集，请检查数据后再重新操作",
  "ApiErrorCode.202103006": "默认角色不允许修改",
  "ApiErrorCode.202103007": "角色最多只能创建30个",
  "ApiErrorCode.202103008": "权限集类型错误，请检查数据后再重新操作",
  "ApiErrorCode.202103009": "权限集不存在，请检测数据后再重新操作",
  "ApiErrorCode.202103010": "权限集key重复",
  "ApiErrorCode.202104001": "用户激活失败，请联系管理员",
  "ApiErrorCode.202104002": "用户已激活",
  "ApiErrorCode.202104003": "用户不存在，请联系管理员",
  "ApiErrorCode.202104004": "用户激活失败，激活链接失效",
  "ApiErrorCode.202104005": "用户激活失败，请联系管理员",
  "ApiErrorCode.202104006": "用户删除失败，请稍后重试",
  "ApiErrorCode.202104007": "不允许通过接口创建超级管理员",
  "ApiErrorCode.202104012": "超级管理员不能被删除",
  "ApiErrorCode.202104013":
    "当前账户在绑定租户里面是超级管理员，请检查已绑定的租户",
  "ApiErrorCode.202105001": "操作过于频繁，请稍后重试",
  "ApiErrorCode.202105002": "邮件验证码发送异常，请稍后重试",
  "ApiErrorCode.202105003": "验证码错误，请检查",
  "ApiErrorCode.202105004": "用户输入错误验证码达最高次数，需要重新获取验证码",
  "ApiErrorCode.202106001": "CDN尚未配置",
  "ApiErrorCode.202106002": "域名所有权验证失败，请稍后重试",
  "ApiErrorCode.202106003": "域名所有权验证尚未完成",
  "ApiErrorCode.202106005": "域名不合法",
  "ApiErrorCode.202106006": "域名尚未被注册",
  "ApiErrorCode.202106007": "域名所有权验证失败，请稍后重试",
  "ApiErrorCode.202106008": "域名CNAME绑定验证失败，请稍后重试",
  "ApiErrorCode.202106009": "域名已存在",
  "ApiErrorCode.202106010": "域名不存在",
  "ApiErrorCode.202106011": "证书格式错误",
  "ApiErrorCode.202106012": "证书不存在",
  "ApiErrorCode.202106013": "证书不匹配",
  "ApiErrorCode.202106014": "证书已存在",
  "ApiErrorCode.202106015": "CDN服务异常，请联系管理员",
  "ApiErrorCode.202106016": "CDN域名已经被占用，请更换",
  "ApiErrorCode.202106017": "CDN配置中，请稍后",
  "ApiErrorCode.202106020": "证书不匹配，请配置该域名的证书",
  "ApiErrorCode.202106021": "域名已配置过CNAME，请清除DNS记录",
  "ApiErrorCode.202106022": "CDN域名高级配置出错",
  "ApiErrorCode.202107001": "请求参数错误",
  "ApiErrorCode.202107002": "查询参数有误",
  "ApiErrorCode.202108001": "验证码错误，请检查您的输入后重试。",
  "ApiErrorCode.202108002": "验证码错误，请检查您的输入后重试。",
  "ApiErrorCode.202108003": "验证码错误，请检查您的输入后重试。",
  "ApiErrorCode.202108004": "创建Open API 密钥对失败，请稍后重试。",
  "ApiErrorCode.202108005":
    "您创建的Open API 密钥对数量已达上限，每个用户最多只能创建10个密钥对。如果您需要创建更多的密钥对，请删除不需要的密钥对后重试。",
  "ApiErrorCode.202108006":
    "您选择的Open API 密钥对数据不存在，请检查您的网络状况后重试。",
  "ApiErrorCode.202108007":
    "您账户绑定的手机号不存在，请联系您的组织管理员检查您的账户状态。",
  "ApiErrorCode.202108008": "无法更新您的Open API 密钥对状态，请稍后重试。",
  "ApiErrorCode.202108009": "当前无法删除您的Open API 密钥对，请稍后重试。",
  "ApiErrorCode.202108010": "配置CDN时，发现CDN可用Domain已经超过上限。",
  "ApiErrorCode.202110001": "审计日志查询时间过长",
  "ApiErrorCode.202111001": "电商集成未完成基础配置",
  "ApiErrorCode.202111002": "Clien_password为必填",
  "ApiErrorCode.202111003": "电商集成基础配置异常",
  "ApiErrorCode.202111004": "电商集成基础配置异常",
  "ApiErrorCode.202111005": "API版本不存在",
  "ApiErrorCode.202111006": "基础配置校验失败",
  "ApiErrorCode.202111007": "基础配置无权限",
  "ApiErrorCode.202111008": "同步任务ID失效",
  "ApiErrorCode.202111009": "同步任务不存在",
  "ApiErrorCode.202111010": "同步任务创建失败",
  "ApiErrorCode.202111011": "同一对象的只能有一个任务处于“启用”状态",
  "ApiErrorCode.202111012": "更新同步任务失败",
  "ApiErrorCode.202111013": "禁用状态的任务才能进行编辑",
  "ApiErrorCode.202111014": "只能删除禁用状态的同步任务",
  "ApiErrorCode.202111015": "获取分类失败",
  "ApiErrorCode.202111018": "获取站点失败",
  "ApiErrorCode.202111019": "获取目录失败",
  "ApiErrorCode.202111020": "获取区域语言失败",
  "ApiErrorCode.202111021": "获取库存失败",
  "ApiErrorCode.202111022": "client pass 加密失败",
  "ApiErrorCode.202111023": "client pass 解密失败",
  "ApiErrorCode.202112001": "抱歉，该CXG组织已经连接。",
  "ApiErrorCode.202112002":
    "抱歉，该Salesforce组织已经连接了另一个CXG组织。请重新选择另一个Salesforce组织进行连接。",
  "ApiErrorCode.202112003": "非法操作",
  "ApiErrorCode.202112004":
    "抱歉，您没有权限操作组织连接。请检查您在Salesforce CRM中的权限和配置。",
  "ApiErrorCode.203101001": "Webhook不存在",
  "ApiErrorCode.203101002": "Webhook已存在",
  "ApiErrorCode.203101003": "Webhook名称已存在",
  "ApiErrorCode.203101004": "Webhook事件类型错误，请检查数据",
  "ApiErrorCode.203101005": "更新webhook前，请先停用",
  "ApiErrorCode.203101006": "健康检查失败，请检查数据或服务器",
  "ApiErrorCode.203101007": "Webhook配置的URL无法识别",
  "ApiErrorCode.203101008": "同个事件类型的webhook任务，最多允许创建两个",
  "ApiErrorCode.203101009": "Webhook配置的URL不在允许列表内",
  "ApiErrorCode.203101010": "密钥加密失败，请联系管理员",
  "ApiErrorCode.204101001": "Storefront不存在",
  "ApiErrorCode.204101002": "Storefront已存在",
  "ApiErrorCode.204101003": "微信小程序绑定失败",
  "ApiErrorCode.204101005": "Storefront App ID已被绑定",
  "ApiErrorCode.204101006": "Storefront 网站地址已被绑定",
  "ApiErrorCode.204101007": "该渠道的Storefront暂不支持更新操作",
  "ApiErrorCode.204102001": "支付商户不存在",
  "ApiErrorCode.204102002": "支付商户已存在",
  "ApiErrorCode.204102003": "支付商户校验失败",
  "ApiErrorCode.204102005":
    "此商家的收款功能已被限制，暂无法支付。商家可以登录微信商户平台/微信支付商家助手小程序查看原因和解决方案。",
  "ApiErrorCode.204103001": "微信服务异常，请稍后重试。",
  "ApiErrorCode.204103002": "微信服务异常，请稍后重试。",
  "ApiErrorCode.204103003": "微信服务异常，请稍后重试",
  "ApiErrorCode.204105001": "请输入正确的appid和appSecret",
  "ApiErrorCode.204105003": "添加或者更新website快捷登录配置出错，请重新尝试",
  "ApiErrorCode.204106003": "请先创建店铺",
  "ApiErrorCode.204106005": "如需开启订单评价，请至少选择一个订单状态",
  "ApiErrorCode.204106006": "错误的可评价订单状态。",
  "ApiErrorCode.204106007": "白名单已达数量上限，添加失败",
  "ApiErrorCode.204106008": "域名无效",
  "ApiErrorCode.204109001": "微信服务异常，请稍后重试",
  "ApiErrorCode.206101001": "创建属性失败",
  "ApiErrorCode.206101002": "更新属性失败",
  "ApiErrorCode.206101003": "删除属性失败",
  "ApiErrorCode.206101004": "属性不存在",
  "ApiErrorCode.206101005": "属性值重复，请重新编辑",
  "ApiErrorCode.206102001": "关联属性失败",
  "ApiErrorCode.206102002": "关联属性更新失败",
  "ApiErrorCode.206102003": "取消关联属性失败",
  "ApiErrorCode.206102004": "分类下属性不存在",
  "ApiErrorCode.206102005": "更新是否显示在渠道失败",
  "ApiErrorCode.206102006": "关联属性已存在",
  "ApiErrorCode.206103001": "创建分类错误",
  "ApiErrorCode.206103002": "更新分类错误",
  "ApiErrorCode.206103003": "删除分类错误",
  "ApiErrorCode.206103004": "分类不存在",
  "ApiErrorCode.206103005": "外部分类ID已存在",
  "ApiErrorCode.206103006": "父分类ID无效",
  "ApiErrorCode.206103007": "删除分类失败，因为分类下存在商品",
  "ApiErrorCode.206103008": "删除分类失败，因为分类下存在子分类",
  "ApiErrorCode.206103009": "分类删除失败因为有已关联的商品",
  "ApiErrorCode.206103010": "创建失败，已超过最大分类层级",
  "ApiErrorCode.206103011": "创建失败，已超过最大分类数量。",
  "ApiErrorCode.206104001": "关联规格失败",
  "ApiErrorCode.206104002": "关联规格更新失败",
  "ApiErrorCode.206104003": "取消关联规格失败",
  "ApiErrorCode.206104004": "分类下规格不存在",
  "ApiErrorCode.206104005": "更新是否显示在渠道失败",
  "ApiErrorCode.206104006": "分类下规格已存在",
  "ApiErrorCode.206105000": "SPU参数失效",
  "ApiErrorCode.206105001": "创建商品失败，请稍后重试",
  "ApiErrorCode.206105002": "更新商品失败",
  "ApiErrorCode.206105003": "删除商品失败",
  "ApiErrorCode.206105004": "商品不存在",
  "ApiErrorCode.206105005": "创建SKU失败",
  "ApiErrorCode.206105006": "更新SKU失败",
  "ApiErrorCode.206105007": "外部商品ID已存在",
  "ApiErrorCode.206105008": "取消关联失败",
  "ApiErrorCode.206105009": "无法编辑，请先下架商品",
  "ApiErrorCode.206105010": "SKU ID不合法",
  "ApiErrorCode.206105011": "商品无法上架",
  "ApiErrorCode.206105012": "SKU不存在",
  "ApiErrorCode.206105013": "库存获取失败",
  "ApiErrorCode.206105014": "商品中不存在该规格",
  "ApiErrorCode.206105015": "商品无法删除",
  "ApiErrorCode.206105016": "销售价已失效",
  "ApiErrorCode.206105017": "库存已失效",
  "ApiErrorCode.206105019": "SKU最多只能生成200个",
  "ApiErrorCode.206105020": "上架失败，至少有一个状态正常的SKU",
  "ApiErrorCode.206105028": "富文本编辑器中字符超出数量上限",
  "ApiErrorCode.206105029": "富文本编辑器中图片超过数量上限",
  "ApiErrorCode.206105030": "富文本编辑器中存在失效域名链接",
  "ApiErrorCode.206106001": "创建规格失败",
  "ApiErrorCode.206106002": "更新规格失败",
  "ApiErrorCode.206106003": "删除规格失败",
  "ApiErrorCode.206106004": "分类规格不存在",
  "ApiErrorCode.206106005": "规格值重复，请重新编辑",
  "ApiErrorCode.206107001": "图片链接非法",
  "ApiErrorCode.206109001": "赠品参与了促销活动无法下架",
  "ApiErrorCode.206109002": "仅支持创建单规格赠品",
  "ApiErrorCode.206109003": "赠品SPU不存在",
  "ApiErrorCode.206109004": "创建赠品SPU失败",
  "ApiErrorCode.206109005": "更新赠品SPU失败",
  "ApiErrorCode.206109006": "删除赠品SPU失败",
  "ApiErrorCode.206109007": "赠品尚未下架无法编辑",
  "ApiErrorCode.206109008": "赠品参与了促销活动无法删除",
  "ApiErrorCode.206109009": "更新赠品失败",
  "ApiErrorCode.206109010": "赠品不存在",
  "ApiErrorCode.206109011": "赠品外部ID已存在",
  "ApiErrorCode.206109012": "赠品尚未创建SKU",
  "ApiErrorCode.206109013": "赠品不存在",
  "ApiErrorCode.206109014": "赠品尚未下架无法编辑",
  "ApiErrorCode.206109015": "赠品SKU ID无效",
  "ApiErrorCode.206109016": "赠品参与了促销活动无法删除",
  "ApiErrorCode.206109017": "赠品尚未下架，SKU更新失败",
  "ApiErrorCode.207101001": "阿里云短信账户未配置",
  "ApiErrorCode.207101002": "配置阿里云短信账户失败",
  "ApiErrorCode.207101003": "删除阿里云短信账户数据失败",
  "ApiErrorCode.207101004": "账户未开通阿里云短信功能或权限",
  "ApiErrorCode.207101006": "阿里云短信账户未配置",
  "ApiErrorCode.207101007": "邮箱SMTP未完成配置",
  "ApiErrorCode.207102001": "当前事件已绑定过该模板",
  "ApiErrorCode.207102003": "当前事件不支持绑定该模版",
  "ApiErrorCode.207102004": "绑定事件和模板失败",
  "ApiErrorCode.207102005": "更新绑定状态失败",
  "ApiErrorCode.207102006": "更新绑定数据失败",
  "ApiErrorCode.207102007": "获取绑定配置失败",
  "ApiErrorCode.207103001": "签名数据不存在",
  "ApiErrorCode.207103002": "短信签名名称已存在",
  "ApiErrorCode.207103003": "短信签名名称不存在",
  "ApiErrorCode.207103004": "添加短信签名失败",
  "ApiErrorCode.207103005": "删除短信签名失败",
  "ApiErrorCode.207104001": "短信模版中出现不支持的变量",
  "ApiErrorCode.207104002": "短信模版不存在或者未被启用",
  "ApiErrorCode.207104003": "短信模版名称已存在",
  "ApiErrorCode.207104004": "短信模版不支持修改",
  "ApiErrorCode.207104005": "更新短信模版失败",
  "ApiErrorCode.207104006": "删除短信模版失败",
  "ApiErrorCode.207104007": "创建短信模版失败",
  "ApiErrorCode.207104010": "模版变量绑定出错",
  "ApiErrorCode.207104011": "模版变量绑定不能为空",
  "ApiErrorCode.207106001": "请求阿里云接口失败",
  "ApiErrorCode.207107001": "发送短信操作太频繁，请稍后重试",
  "ApiErrorCode.207107002": "安全短信发送失败, 请稍后再试",
  "ApiErrorCode.207107003": "安全短信验证失败, 验证码错误",
  "ApiErrorCode.207107004": "安全短信配置缺失",
  "ApiErrorCode.207107005": "触发发送短信限额流控",
  "ApiErrorCode.207108001": "邮件发送太频繁，请稍后重试",
  "ApiErrorCode.207108002": "发送邮件验证码失败",
  "ApiErrorCode.207108004": "平台邮件配置丢失",
  "ApiErrorCode.207108005": "非法的阿里云短信签名类型",
  "ApiErrorCode.207108006": "非法的阿里云短信模板类型",
  "ApiErrorCode.207108007": "短信模板不存在",
  "ApiErrorCode.207108008": "短信模板不处于审核失败状态,不许更新",
  "ApiErrorCode.207108009": "当前状态下不能删除短信模板",
  "ApiErrorCode.207108010": "从阿里云同步签名失败",
  "ApiErrorCode.207108011": "从阿里云同步短信模板失败",
  "ApiErrorCode.207109001": "SMTP邮件配置",
  "ApiErrorCode.207109002": "测试邮件发送失败，请检查SMTP配置",
  "ApiErrorCode.210101008": "该订单状态不支持编辑",
  "ApiErrorCode.210101009": "更新部分订单信息失败",
  "ApiErrorCode.211101001":
    "上传图片失败，支持图像格式为：jpg, png, gif, tif, bmp, svg",
  "ApiErrorCode.211101002": "上传失败",
  "ApiErrorCode.211101003": "上传文件失败，请先配置CDN",
  "ApiErrorCode.211101004": "生成小程序二维码失败",
  "ApiErrorCode.211101005": "上传文件失败，url与CDN域名不匹配",
  "ApiErrorCode.211101006": "上传文件失败，无法获取CDN域名",
  "ApiErrorCode.211101007": "上传图片失败，图片大小需要介于1KB至5MB之间",
  "ApiErrorCode.211101008": "上传文件失败，无法下载远端文件",
  "ApiErrorCode.211101009": "上传文件失败，文件格式不合法",
  "ApiErrorCode.211101010": "上传文件失败，文件内容不合法",
  "ApiErrorCode.211101011": "上传视频封面失败",
  "ApiErrorCode.211101012": "上传视频失败",
  "ApiErrorCode.211101013": "上传视频失败，视频大小需介于1KB至200MB之间",
  "ApiErrorCode.211101014": "上传视频失败，视频内容不合法",
  "ApiErrorCode.211101015": "错误的参数",
  "ApiErrorCode.211101016": "链接无法添加，请确认是否已添加到白名单",
  "ApiErrorCode.211101018": "链接无法添加，请确认是否已添加到白名单",
  "ApiErrorCode.211101019": "视频不存在",
  "ApiErrorCode.211102001": "上传视频失败，转码失败",
  "ApiErrorCode.211103001": "上传失败，保存素材失败",
  "ApiErrorCode.211104001": "未能创建阿里云policy",
  "ApiErrorCode.211104002": "非法的contentType",
  "ApiErrorCode.211104003": "非法的业务系统",
  "ApiErrorCode.211104004": "存在非法的文件ID",
  "ApiErrorCode.211104005": "非法的aliyun policy或者该policy已过期",
  "ApiErrorCode.211104006": "签名或者aliyun policy非法",
  "ApiErrorCode.211104008": "未能验证文件",
  "ApiErrorCode.211104009": "文件处于验证中",
  "ApiErrorCode.211104011": "文件不存在",
  "ApiErrorCode.211104012": "文件太大",
  "ApiErrorCode.211104013": "非法的文件拓展名",
  "ApiErrorCode.211104014": "业务方未配置文件校验的检查规则",
  "ApiErrorCode.211104015": "文件检验，不支持该文件分类",
  "ApiErrorCode.211104016": "播放时间超过限制",
  "ApiErrorCode.211104017": "文件帧率过大",
  "ApiErrorCode.211104018": "文件码率过大",
  "ApiErrorCode.211104019": "非法的文件头",
  "ApiErrorCode.211104020": "文件上传太过频繁",
  "ApiErrorCode.212101101": "客户数据不存在",
  "ApiErrorCode.212101102": "找不到店铺数据",
  "ApiErrorCode.212101103": "移除黑名单客户失败",
  "ApiErrorCode.212101104": "导入的文件为无效文件",
  "ApiErrorCode.212101105": "未找到导入记录",
  "ApiErrorCode.212101106": "未完成导入",
  "ApiErrorCode.212101107": "未找到导入失败的文件",
  "ApiErrorCode.212101108": "导入失败的文件已过期",
  "ApiErrorCode.213101001": "自定义字段名称重复",
  "ApiErrorCode.213101002": "创建自定义字段失败",
  "ApiErrorCode.213101003": "不存在该自定义字段",
  "ApiErrorCode.213101004": "自定义字段超出数量限制",
  "ApiErrorCode.213101005": "更新自定义字段失败",
  "ApiErrorCode.213101006": "自定义字段类型不符要求",
  "ApiErrorCode.213101007": "自定义字段业务类型不符要求",
  "ApiErrorCode.213102001": "没有权限关联自定义字段",
  "ApiErrorCode.213102002": "自定义字段值不满足格式要求",
  "ApiErrorCode.213102003": "没有权限执行相关操作",
  "ApiErrorCode.214101001": "导出失败",
  "ApiErrorCode.214101002": "已达到今天最大的导出次数，请明天再尝试",
  "ApiErrorCode.214101003": "操作频繁，请5分钟后再试",
  "ApiErrorCode.214101004": "重新生成失败",
  "ApiErrorCode.214101005": "导出记录不存在",
  "ApiErrorCode.214101006": "获取下载链接失败，请稍后再试",
  "ApiErrorCode.214101007": "请求阿里云接口失败",
  "ApiErrorCode.214101008": "文件正在处理中，请稍后再试",
  "ApiErrorCode.214101009": "导出的数据时间超过允许的最长时间范围",
  "ApiErrorCode.214101010": "无效分群ID",
  "ApiErrorCode.214101011": "检查Segment的状态为Active，再重新尝试",
  "ApiErrorCode.214101101": "创建促销活动失败，请稍后重试",
  "ApiErrorCode.214101102": "更新促销活动失败，请稍后重试",
  "ApiErrorCode.214101104": "因为促销活动的状态，或时间配置，无法开始活动",
  "ApiErrorCode.214101105": "该促销活动的状态不允许结束",
  "ApiErrorCode.214101106": "该促销活动的状态不允许编辑",
  "ApiErrorCode.214101107": "同一店铺全场商品满赠活动最多允许5个，请重新选择",
  "ApiErrorCode.214101108": "仅能删除草稿、未开始状态的促销活动",
  "ApiErrorCode.214101109": "规则门槛必须逐级递增",
  "ApiErrorCode.214101110": "仅能暂停进行中的活动",
  "ApiErrorCode.214101111": "选中赠品已被下架",
  "ApiErrorCode.214101112": "选中赠品已被其他活动占用",
  "ApiErrorCode.214101113": "选中商品已被删除",
  "ApiErrorCode.214101114": "选中商品已被其他活动占用",
  "ApiErrorCode.214101115": "促销活动不存在",
  "ApiErrorCode.214101118": "创建全场promotion数量超出限制",
  "ApiErrorCode.214101119": "活动优惠异常，无法创建订单",
  "ApiErrorCode.214102108": "删除促销活动失败",
  "ApiErrorCode.300102000": "抱歉，服务器出错。请联系管理员",
  "ApiErrorCode.300102001": "SKU失效，请重新下单",
  "ApiErrorCode.300102002": "支付失败，请切换其他支付方式或稍后再试",
  "ApiErrorCode.300102003": "订单已支付成功，请勿重复提交",
  "ApiErrorCode.300102011": "参数异常",
  "ApiErrorCode.300102013": "参数异常",
  "ApiErrorCode.300102021": "操作失败，请稍后重试",
  "ApiErrorCode.300102022": "用户不存在，请检查",
  "ApiErrorCode.600101104":
    "您输入的URL路径格式有误，请确保路径以https://开始，不支持ip格式域名。",
  "ApiErrorCode.600101106": "KMS解密错误",
  "ApiErrorCode.2009001005": "cookies已被强制过期",
  "ApiErrorCode.2009004001": "此组织中没有可用的“Assets”",
  "ApiErrorCode.2009004002":
    "该Org无法使用 社交电商，请与您的管理员确认是否完成购买或续费。",
  "ApiErrorCode.2009004003":
    "该Org无法使用 社交营销，请与您的管理员确认是否完成购买或续费。",
  "ApiErrorCode.2009004004":
    "该Org无法使用 CRM集成，请与您的管理员确认是否完成购买或续费。",
  "ApiErrorCode.000": "抱歉，服务器出错。请联系管理员",
  "ApiErrorCode.001": "没有权限，请联系管理员",
  "ApiErrorCode.002": "请检查输入是否有效",
  "ApiErrorCode.003": "参数格式错误",
  "ApiErrorCode.004": "请联系管理员",
  "ApiErrorCode.006": "请联系管理员",
  "ApiErrorCode.009": "请求方式不支持",
  "ApiErrorCode.010": "参数错误",
  "ApiErrorCode.011": "数据不存在",
  "@business.custom-field.update-value.empty": "暂无可更新自定义字段",
  "@business.custom-field.update-value.title": "更新自定义字段",
  "@business.custom-field.update.writeable.modal.notification":
    "您只能对已启用BusinessOpenAPI写能力的字段修改它的值",
  "@business.custom=field.update.writeable.is.empty":
    "暂无启用BusinessOpenAPI写能力的自定义字段",
  "AfterSale.Detail.after-sale-detail": "售后详情",
  "AfterSale.Detail.after-sale-info": "售后信息",
  "AfterSale.Detail.after-sale-info.created_at": "申请时间",
  "AfterSale.Detail.after-sale-info.description": "售后说明",
  "AfterSale.Detail.after-sale-info.estimated_refund_amount": "应退金额",
  "AfterSale.Detail.after-sale-info.evidence_images": "售后凭证",
  "AfterSale.Detail.after-sale-info.reason": "售后原因",
  "AfterSale.Detail.after-sale-product": "售后商品",
  "AfterSale.Detail.after-sale-product.is_giveaway": "赠品",
  "AfterSale.Detail.after-sale-product.quantity": "数量",
  "AfterSale.Detail.after-sale-status": "售后状态",
  "AfterSale.Detail.custom-field": "自定义字段",
  "AfterSale.Detail.delivery-info": "退货信息",
  "AfterSale.Detail.delivery-info.carrier_code": "物流公司编码",
  "AfterSale.Detail.delivery-info.carrier_company": "物流公司名称",
  "AfterSale.Detail.delivery-info.contact_phone": "联系手机",
  "AfterSale.Detail.delivery-info.tracking_number": "物流单号",
  "AfterSale.Detail.pageHeader.after_sales_id": "售后ID",
  "AfterSale.Detail.pageHeader.channel_name": "渠道名称",
  "AfterSale.Detail.pageHeader.order_id": "订单ID",
  "AfterSale.Detail.pageHeader.storefront_name": "店铺名称",
  "AfterSale.Detail.pageHeader.type": "售后类型",
  "AfterSale.Detail.process-flows": "售后流转记录",
  "AfterSale.Detail.process-flows.status-remark": "状态描述",
  "AfterSale.Detail.status-records": "历史记录",
  "AfterSale.Detail.title": "售后详情",
  "AfterSale.List.title": "售后列表",
  "AfterSale.filter.aftersales_id": "售后ID",
  "AfterSale.filter.aftersales_id.placeholder": "请输入售后ID",
  "AfterSale.filter.apply_end_time": "申请结束时间",
  "AfterSale.filter.apply_start_time": "申请开始时间",
  "AfterSale.filter.channel": "渠道名称",
  "AfterSale.filter.created_at": "申请时间",
  "AfterSale.filter.order_id": "订单ID",
  "AfterSale.filter.order_id.placeholder": "请输入订单ID",
  "AfterSale.filter.status": "售后状态",
  "AfterSale.filter.storefront": "店铺名称",
  "AfterSale.filter.type": "售后类型",
  "AfterSale.status.1": "申请退款中",
  "AfterSale.status.10": "包裹接收",
  "AfterSale.status.11": "退货失败",
  "AfterSale.status.12": "售后关闭",
  "AfterSale.status.2": "拒绝退款",
  "AfterSale.status.3": "退款中",
  "AfterSale.status.4": "退款成功",
  "AfterSale.status.5": "退款失败",
  "AfterSale.status.6": "申请退货中",
  "AfterSale.status.7": "拒绝退货",
  "AfterSale.status.8": "同意退货",
  "AfterSale.status.9": "退货中",
  "AfterSale.table.after_sales_id": "售后ID",
  "AfterSale.table.channel": "渠道名称",
  "AfterSale.table.created_at": "申请时间",
  "AfterSale.table.estimated_refund_amount": "应退金额",
  "AfterSale.table.order_id": "订单ID",
  "AfterSale.table.status": "售后状态",
  "AfterSale.table.storefront": "店铺名称",
  "AfterSale.table.type": "售后类型",
  "AfterSale.title": "售后",
  "AfterSale.type.1": "未发货退款",
  "AfterSale.type.2": "已发货仅退款",
  "AfterSale.type.3": "退货退款",
  "Auth.BindAuthenticator.card.info.row1":
    "为了您的账号安全，Salesforce Social Commerce & Messaging 为您开启了多因子身份验证，每次登录时，输入账号密码后，您还需要使用绑定的Authenticator APP输入您的安全代码，以确保登录者是你本人。",
  "Auth.BindAuthenticator.card.info.row2":
    "您还未绑定您的Authenticator, 请完成以下步骤，更多相关信息，请查看 {link}",
  "Auth.BindAuthenticator.card.info.bound.row1":
    "为了您的账号安全，Salesforce Social Commerce & Messaging 为您开启了多因子身份验证，每次登录时，输入账号密码后，您还需要使用绑定的Authenticator APP输入您的安全代码，以确保登录者是你本人。",
  "Auth.BindAuthenticator.card.info.bound.row2":
    "如需换绑您的Authenticator, 需要完成以下步骤，更多相关信息，请查看 {link}",
  "Auth.BindAuthenticator.card.info.link": "用户指南",
  "Auth.BindAuthenticator.card.step.1.info":
    "扫码成功后，请完成首次校验，完成绑定",
  "Auth.BindAuthenticator.card.step.1.label":
    "请使用Authenticator APP扫描QRCode",
  "Auth.BindAuthenticator.card.step.1.title": "第一步",
  "Auth.BindAuthenticator.card.step.2.form.label":
    "请输入您的Authenticator的安全代码",
  "Auth.BindAuthenticator.card.step.2.label":
    "请输入您扫码绑定的Authenticator的安全代码",
  "Auth.BindAuthenticator.card.step.2.title": "第二步",
  "Auth.BindAuthenticator.card.tip.1":
    "您需要使用手机，前往安卓或IOS的应用商店下载 Authenticator APP，我们推荐您使用 Salesforce Authenticator，同时我们也支持 Google Authenticator, Microsoft Authenticator 等其他厂商的 Authenticator 应用",
  "Auth.BindAuthenticator.card.tip.2":
    "请用账号“{email}”绑定的手机号“{phone}”进行短信验证",
  "Auth.BindAuthenticator.card.title": "绑定Authenticator",
  "Auth.BindAuthenticator.form.hint.placeholder": "请输入短信验证码",
  "Auth.BindAuthenticator.sms.hint.placeholder": "请输入验证码",
  "Auth.InputAuthenticator.code.label": "请输入您的Authenticator的安全代码",
  "Auth.InputAuthenticator.code.verify.error": "MFA安全代码错误",
  "Auth.InputAuthenticator.form.hint.placeholder": "请输入安全代码",
  "Auth.InputAuthenticator.reset.link": "重绑Authenticator",
  "Auth.InputAuthenticator.title": "请输入您的Authenticator的安全代码",
  "Auth.Login.side.head.info": "由阿里云运营",
  "Auth.Login.side.head.title": "Salesforce 互联网关",
  "Auth.Login.side.informationSet": [
    "为中国打造的专属产品，提供与关键本地平台集成",
    "多渠道数据整合，打造360度用户画像",
    "借助阿里云的力量，轻松、安全且灵活地扩展",
  ],
  "Auth.Login.tip":
    "Salesforce 互联网关是全球首屈一指的平台，为各行业顶尖品牌提供更快、更安全的方案",
  "Auth.Login.title": "登录",
  "Auth.SelectOrg.account.invalid.error":
    "您的账号已失效，如有疑问请联系管理员！",
  "Auth.SelectOrg.announcement.modal.label.publish-time": "发布时间：",
  "Auth.SelectOrg.announcement.modal.label.publisher": "发布人：",
  "Auth.SelectOrg.announcement.modal.title": "系统公告",
  "Auth.SelectOrg.asset.no-permission": "该组织没有可用的Asset，请联系管理员",
  "Auth.SelectOrg.org.selection.error": "请选择组织",
  "Auth.SelectOrg.org.selection.finish.label": "进入系统首页",
  "Auth.SelectOrg.org.selection.label": "组织",
  "Auth.SelectOrg.org.selection.placeholder": "请选择组织",
  "Auth.SelectOrg.org.selection.title": "请选择组织",
  "Auth.SelectOrganization.title": "选择组织",
  "Auth.TenantActivation.edit.form.confirmPassword": "确认密码",
  "Auth.TenantActivation.edit.form.confirmPassword.placeholder":
    "请输入确认密码",
  "Auth.TenantActivation.edit.form.confirmPassword.validateError":
    "请输入正确的密码",
  "Auth.TenantActivation.edit.form.password": "新密码",
  "Auth.TenantActivation.edit.form.password.placeholder": "请输入登录密码",
  "Auth.TenantActivation.edit.form.password.validateError":
    "请输入密码至少包含大写字母+数字+特殊字符，长度至少10位",
  "Auth.TenantActivation.edit.form.submit": "登录",
  "Auth.TenantActivation.edit.header": "设置密码",
  "Auth.TenantActivation.edit.phone.code.label": "获取验证码",
  "Auth.TenantActivation.edit.phone.code.send.success": "验证码已发送，请查收!",
  "Auth.TenantActivation.edit.phone.form.code": "验证码",
  "Auth.TenantActivation.edit.phone.form.phone": "手机号",
  "Auth.TenantActivation.edit.phone.form.phone.valid": "手机号格式不正确",
  "Auth.TenantActivation.edit.phone.tip":
    "为了您的账号安全，Salesforce Social Commerce & Messaging 需要您的手机号进行多因子身份验证",
  "Auth.TenantActivation.edit.phone.title": "设置手机号",
  "Auth.TenantActivation.edit.ps.tip.1": "密码至少包含大写字母+数字+特殊字符",
  "Auth.TenantActivation.edit.ps.tip.2": "长度至少10位",
  "Auth.TenantActivation.edit.ps.title": "设置登陆密码",
  "Auth.TenantActivation.expire.action": "返回登录",
  "Auth.TenantActivation.expire.content.regard": "您好",
  "Auth.TenantActivation.expire.content.row_1": "激活链接已失效",
  "Auth.TenantActivation.expire.content.row_2": "请联系您的管理员",
  "Auth.TenantActivation.expire.header": "激活链接已失效",
  "Auth.TenantActivation.title": "设置密码",
  "Auth.TenantJoin.edit.content.row_1": "确认加入 ”{orgName}“ 组织么？",
  "Auth.TenantJoin.edit.content.row_2":
    "成功加入后将能在登录后直接访问该组织的资源",
  "Auth.TenantJoin.edit.header": "加入新组织",
  "Auth.TenantJoin.success.action": "立即登录",
  "Auth.TenantJoin.success.content": "您已成功加入 ”{orgName}“ 组织！",
  "Auth.TenantJoin.title": "加入新组织",
  "Auth.title": "基于阿里云的Salesforce",
  "Channel.CCApi.unActive": "未开通Salesforce Social Commerce API",
  "Channel.Corp.title": "线下渠道",
  "Channel.CorpList.header.create": "创建线下门店",
  "Channel.CorpList.storeCard.ali.tips_1":
    "请选择支付宝当面付能力，完成商家平台签约",
  "Channel.CorpList.storeCard.ali.tips_2": "支付宝扫码授权",
  "Channel.CorpList.storeCard.ali.tips_2.event.auth": "重新授权",
  "Channel.CorpList.storeCard.ali.tips_2.event.unAuth": "扫码授权",
  "Channel.CorpList.storeCard.ali.tips_2.status.auth": "已授权",
  "Channel.CorpList.storeCard.ali.tips_2.status.unAuth": "未授权",
  "Channel.CorpList.storeCard.ali.tips_3.event.signed":
    "已开通支付宝当面付能力",
  "Channel.CorpList.storeCard.ali.tips_3.event.unSign": "校验状态",
  "Channel.CorpList.storeCard.bottom.edit-name": "编辑名称",
  "Channel.CorpList.storeCard.bottom.form.edit-name": "门店名称",
  "Channel.CorpList.storeCard.step1": "步骤一",
  "Channel.CorpList.storeCard.step2": "步骤二",
  "Channel.CorpList.storeCard.step3": "步骤三",
  "Channel.CorpList.storeCard.wx.tips_1": "开通微信商户号",
  "Channel.CorpList.storeCard.wx.tips_2": "商户号绑定小程序",
  "Channel.CorpList.storeCard.wx.tips_3": "签约状态",
  "Channel.CorpList.storeCard.wx.tips_3.status.signed": "已签约",
  "Channel.CorpList.storeCard.wx.tips_3.status.unSign": "未签约",
  "Channel.CorpList.title": "创建线下门店",
  "Channel.WeChatMiniProgramList.actions.button": "接入微信小程序",
  "Channel.WeChatMiniProgramList.cardItem.api.completed":
    "已开通Salesforce Social Commerce API",
  "Channel.WeChatMiniProgramList.cardItem.api.link": "去开发",
  "Channel.WeChatMiniProgramList.cardItem.bottomNode.close": "停用店铺",
  "Channel.WeChatMiniProgramList.cardItem.bottomNode.open": "启用店铺",
  "Channel.WeChatMiniProgramList.cardItem.rightNode.status.disabled": "已停用",
  "Channel.WeChatMiniProgramList.cardItem.rightNode.status.enabled": "已启用",
  "Channel.WeChatMiniProgramList.cardItem.rightNode.text": "店铺开通日期",
  "Channel.WeChatMiniProgramList.cardItem.wx.add": "绑定",
  "Channel.WeChatMiniProgramList.cardItem.wx.completed": "已绑定微信支付",
  "Channel.WeChatMiniProgramList.cardItem.wx.open.date": "开通时间",
  "Channel.WeChatMiniProgramList.cardItem.wx.openWay": "如何开通微信支付能力？",
  "Channel.WeChatMiniProgramList.cardItem.wx.re-bind": "重新绑定",
  "Channel.WeChatMiniProgramList.cardItem.wx.uncompleted": "未绑定微信支付",
  "Channel.WeChatMiniProgramList.pageHeader.info": "{num}个项目",
  "Channel.WeChatMiniProgramList.title": "微信小程序",
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.codeLink":
    "下载样本小程序前端代码.zip",
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.qrcodeText": "扫一扫进行体验",
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.row_1.intro":
    "1.已有小程序前端代码，可直接查阅  {link} 进行API切换，以完成绑定流程。",
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.row_1.intro.link":
    "如何接入Salesforce Social Commerce API？",
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.row_2.intro":
    "2.您可选择Salesforce Social Commerce提供的样本小程序前端代码，自行上传，请点击预览体验样本小程序。",
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.title":
    "接入 Salesforce Social Commerce API",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.error.description":
    "该小程序已被本组织绑定",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.error.retry": "重新授权",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.error.title": "授权失败",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.success.description":
    "已获取App ID、Access Token",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.success.title":
    "授权成功，新店铺已开通",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.title": "小程序授权",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.success.description":
    "该小程序已开通微信支付，已获取Merchant ID、Secret Key",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.success.title":
    "绑定微信支付成功",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.title": "绑定微信支付",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.warning.bottomTips":
    "您也可以跳过该步骤进入下一步，在【渠道 - 微信小程序】页面可再次提交信息",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.warning.description_1":
    "请查阅",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.warning.description_2":
    "如何开通微信支付？",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.warning.submit": "提交校验",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.warning.title":
    "该小程序未开通微信支付",
  "Channel.WeChatMiniProgramPost.completed": "完成",
  "Channel.WeChatMiniProgramPost.title": "接入微信小程序",
  "Channel.Website.alipay.active": "已绑定支付宝网站支付",
  "Channel.Website.alipay.bindAuth.failed": "授权失败, 请刷新二维码重新授权",
  "Channel.Website.alipay.bindAuth.success": "授权成功, 已经绑定支付宝网站支付",
  "Channel.Website.alipay.modal.scanned": "我已扫码",
  "Channel.Website.alipay.unActive": "未绑定支付宝网站支付",
  "Channel.Website.alipay.unActive.action": "绑定",
  "Channel.Website.alipay.unActive.tip": "如何开通支付宝网址支付能力？",
  "Channel.Website.auth.qrcode.refresh": "点击刷新二维码",
  "Channel.Website.modal.wx-login.form.label.app_id": "网站应用APP ID",
  "Channel.Website.modal.wx-login.form.label.app_secret": "网站应用APP Secret",
  "Channel.Website.modal.wx-login.form.submit.success": "绑定成功",
  "Channel.Website.modal.wx-login.info":
    "接入网站应用微信登录需要提供以下参数。 参考文档：{link}",
  "Channel.Website.modal.wx-login.info.link": "网站应用微信登录开发指南。",
  "Channel.Website.modal.wx-login.title": "绑定微信登录",
  "Channel.Website.pay.re-auth": "重新绑定",
  "Channel.WebsiteList.actions.wx-login": "微信登录",
  "Channel.WebsiteList.ali.authModal.website.info":
    "请先开通支付宝网站支付再扫码授权，参考文档: {link}",
  "Channel.WebsiteList.ali.authModal.website.link": "支付宝电脑网站支付",
  "Channel.WebsiteList.ali.authModal.website.tip1":
    "1. 使用支付宝客户端登录网页应用管理员的账号进行扫码授权。",
  "Channel.WebsiteList.ali.authModal.website.tip2":
    "2. 选择要授权的网页应用并点击【签署并授权】。",
  "Channel.WebsiteList.ali.authModal.website.title": "绑定支付宝网站支付",
  "Channel.WebsiteList.edit": "修改网址",
  "Channel.WebsiteList.moreUrl": "更多网址",
  "Channel.WebsiteList.title": "网站",
  "Channel.WebsitePost.ChinaCloudApi.codeLink": "下载样本网站前端代码.zip",
  "Channel.WebsitePost.ChinaCloudApi.mark": "预览链接",
  "Channel.WebsitePost.ChinaCloudApi.qrcodeText": "扫一扫进行体验",
  "Channel.WebsitePost.ChinaCloudApi.row_1.intro_1":
    "1.已有样本网站前端代码，可直接查阅：",
  "Channel.WebsitePost.ChinaCloudApi.row_1.intro_2":
    "如何接入Salesforce Social Commerce API？",
  "Channel.WebsitePost.ChinaCloudApi.row_1.intro_3":
    "进行API切换，以完成绑定流程。",
  "Channel.WebsitePost.ChinaCloudApi.row_2.intro":
    "2.您可选择Salesforce Social Commerce提供的样本网站前端代码，自行上传，请点击预览体验样本网站。",
  "Channel.WebsitePost.actions.button": "接入网站",
  "Channel.WebsitePost.steps.bindWebSite": "绑定网站",
  "Channel.WebsitePost.steps.bindWebSite.bindFailed": "绑定失败",
  "Channel.WebsitePost.steps.bindWebSite.bindFailed.bindAlready":
    "该网站已被本组织绑定",
  "Channel.WebsitePost.steps.bindWebSite.bindFailed.reBind": "重新绑定",
  "Channel.WebsitePost.steps.bindWebSite.bindSuccess": "绑定成功，新店铺已开通",
  "Channel.WebsitePost.steps.bindWebSite.form.hostName": "网址",
  "Channel.WebsitePost.steps.bindWebSite.form.hostName.addMore":
    "+ 绑定更多网址",
  "Channel.WebsitePost.steps.bindWebSite.form.hostName.placeholder":
    "请输入你要绑定的网址",
  "Channel.WebsitePost.steps.bindWebSite.form.hostName.validate":
    "请勿输入相同的URL",
  "Channel.WebsitePost.steps.bindWebSite.form.siteName": "网站名称",
  "Channel.WebsitePost.steps.bindWebSite.form.siteName.placeholder":
    "请输入网站名称",
  "Channel.WebsitePost.steps.bindWebSite.form.siteName.validate":
    "请输入完整有效的网址",
  "Channel.WebsitePost.steps.bindWebSite.form.submit.tips_1":
    "1.请输入完整有效的网址。",
  "Channel.WebsitePost.steps.bindWebSite.form.submit.tips_2":
    "2.当前被绑定的网址无法再次绑定。",
  "Channel.WebsitePost.steps.openPay": "开通网页支付能力",
  "Channel.WebsitePost.steps.openPay.info": "您可以选择绑定以下网站支付方式",
  "Channel.WebsitePost.steps.openPay.info.tip":
    "您也可以跳过该步骤进入下一步，在【渠道 - 网站】页面可再次提交信息",
  "Channel.WebsitePost.title": "接入网站",
  "Channel.action.preview": "点击预览",
  "Channel.components.MerchantPostModal.fail":
    "接口校验失败，请填写正确的该应用已绑定的微信商户信息",
  "Channel.components.MerchantPostModal.miniapp.heading": "绑定微信支付",
  "Channel.components.MerchantPostModal.miniapp.tips":
    "若已开通微信支付，请提供以下参数。若未开通，请参考文档：{link}",
  "Channel.components.MerchantPostModal.miniapp.tips.link":
    "小程序接入微信支付",
  "Channel.components.MerchantPostModal.submit": "提交校验",
  "Channel.components.MerchantPostModal.success":
    "接口校验通过，已开通微信网站支付能力",
  "Channel.components.MerchantPostModal.website.heading": "绑定微信网站支付",
  "Channel.components.MerchantPostModal.website.tips":
    "若已开通微信网站支付，请提供以下参数。若未开通，请参考文档：{link}",
  "Channel.components.MerchantPostModal.website.tips.link": "网站接入微信支付",
  "Channel.components.StoreStatusModal.activateContent":
    "启用店铺将允许该店铺ID继续访问Salesforce Social Commerce API，并将恢复该店铺应用的正常使用。",
  "Channel.components.StoreStatusModal.activateHeading": "启用店铺",
  "Channel.components.StoreStatusModal.inactivateContent":
    "停用店铺将禁止该店铺ID继续访问Salesforce Social Commerce API，但不影响已有数据。该操作将影响该店铺应用的正常使用，请慎重操作。",
  "Channel.components.StoreStatusModal.inactivateHeading": "停用店铺",
  "Channel.title": "渠道",
  "Channel.website.wxpay.active": "已绑定微信网站支付",
  "Channel.website.wxpay.unActive": "未绑定微信网站支付",
  "Channel.website.unionPay.unActive": "未绑定银联支付",
  "Channel.website.unionPay.active": "银联支付已绑定",
  "Channel.website.unionPay.authModal.help.info":
    "绑定您的银联账号需要您提供以下信息，更多信息可查看 {link}",
  "Channel.website.unionPay.authModal.help.link": "银联官方文档",
  "Channel.website.unionPay.authModal.bindForm.merchant": "商户号",
  "Channel.website.unionPay.authModal.bindForm.merchantPwd": "商户私钥正式密码",
  "Channel.website.unionPay.authModal.bindForm.credentials":
    "请提供银联账号的 商户私钥证书/中级证书与根证书 您的证书将被加密存储，并仅用于该店铺的支付行为",
  "Channel.website.unionPay.authModal.title": "绑定银联支付",
  "Channel.website.unionPay.authModal.bindForm.privateCert":
    "请上传商户私钥证书（.pfx）",
  "Channel.website.unionPay.authModal.bindForm.rootCer": "请上传根证书（.cer）",
  "Channel.website.unionPay.authModal.bindForm.middleCer":
    "请上传中级证书（.cer）",
  "Channel.website.unionPay.authModal.bindForm.merchant.placeholder":
    "商户号不大于50个字符",
  "Channel.website.unionPay.authModal.bindForm.merchantPwd.placeholder":
    "商户私钥正式密码为6位纯数字",
  "Channel.website.unionPay.authModal.bindForm.privateCert.change":
    "更换商户私钥证书（.pfx）",
  "Channel.website.unionPay.authModal.bindForm.middleCer.change":
    "更换中级证书（.cer）",
  "Channel.website.unionPay.authModal.bindForm.rootCer.change":
    "更换根证书（.cer）",
  "Channel.website.unionPay.authModal.re-bind.title": "重新绑定银联支付",
  "Channel.customerList.title": "请选择该店铺的Customer List",
  "Channel.customerList.tips":
    "请注意Customer List选择后将无法修改，更多信息请查阅 {link}",
  "Channel.customerList.tips.link": "用户指南",
  "Channel.customerList.useGroupId.enable.title":
    "Exiting Customer List：与其他店铺共用客户账号",
  "Channel.customerList.useGroupId.enable.tips":
    "选择现有的Customer List，该店铺将与您选择的店铺群共用一套用户体系，在任一店铺中注册的用户，使用相同的账号密码，可以登录到共用用户体系的其他店铺中，并共享用户行为记录和订单记录。",
  "Channel.customerList.storefrontGroup.validateError":
    "请选择 Customer List ID",
  "Channel.customerList.storefrontGroup.store": "与该店铺共用客户体系的店铺",
  "Channel.customerList.storefrontGroup.store.website": "网站：",
  "Channel.customerList.storefrontGroup.store.wechat-mp": "微信小程序：",
  "Channel.customerList.useGroupId.disable.title":
    "New Customer List：不与现有店铺共用客户账号",
  "Channel.customerList.useGroupId.disable.tips":
    "创建新的Customer List，该店铺创建成功后，访问者需要从注册开始。该店铺将无法与现有店铺共用客户数据与订单记录。",
  "Channel.steps.selectCustomerList": "选择店铺的Customer List",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.form.title":
    "选择已授权小程序",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.form.tips":
    "若未选到目标小程序，请先前往{link}进行微信小程序授权",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.form.tips.link":
    "【设置-社交帐号】",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.form.wechat-mp.label":
    "微信小程序",
  "Channel.customerListModal.title": "共用客户的店铺",
  "Channel.customerListModal.tips": "与 {storefront} 共享客户表的店铺为：",
  "Channel.customerListModal.trigger": "查看共用Customer List的店铺",
  "CustomerManagement.CustomerDetail.title": "客户详情",
  "CustomerManagement.account-info": "账号信息",
  "CustomerManagement.activity.AddToCart": "将某商品加入购物车",
  "CustomerManagement.activity.AfterSales": "申请售后",
  "CustomerManagement.activity.BeginPay": "发起支付",
  "CustomerManagement.activity.CancelOrderManual": "手动取消订单",
  "CustomerManagement.activity.CancelOrderTimeout": "超时未支付取消订单",
  "CustomerManagement.activity.CancelPay": "取消支付",
  "CustomerManagement.activity.CollectProduct": "收藏产品",
  "CustomerManagement.activity.CreateOrder": "创建订单",
  "CustomerManagement.activity.EnterProductPage": "进入某商品详情页",
  "CustomerManagement.activity.PaySuccess": "支付成功",
  "CustomerManagement.activity.ReceiveGoods": "确认收货",
  "CustomerManagement.activity.UserRegistry": "客户注册",
  "CustomerManagement.activity.subscribeBackInStore": "订阅到货通知",
  "CustomerManagement.activity.unsubscribeBackInStore": "取消订阅到货通知",
  "CustomerManagement.address-book-list": "收货地址",
  "CustomerManagement.aftersales-records": "售后记录",
  "CustomerManagement.associated-accounts": "关联账号",
  "CustomerManagement.associated-accounts.rule-one":
    "1.不同店铺的微信小程序账号，根据UnionID是否相同，自动关联在一起",
  "CustomerManagement.associated-accounts.rule-title": "规则说明",
  "CustomerManagement.associated-accounts.rule.content":
    "客户在同一个的CustomerList里因注册参数不同而导致有多个账户的情况下，我们将通过手机号/邮箱/UnionID 查询同一个CustomerList的用户记录，在关联账户中进行展示。",
  "CustomerManagement.associated-accounts.rule-two":
    "2.不同店铺的网站账号，根据客户手机号是否相同，自动关联在一起",
  "CustomerManagement.base-info": "基本信息",
  "CustomerManagement.base-info.channel-name": "渠道名称",
  "CustomerManagement.base-info.register-channel-name": "注册渠道",
  "CustomerManagement.base-info.register-storefront-name": "注册店铺",
  "CustomerManagement.base-info.login-identifier": "注册账户",
  "CustomerManagement.base-info.city": "所在城市",
  "CustomerManagement.base-info.country": "所在国家",
  "CustomerManagement.base-info.district": "所在区县",
  "CustomerManagement.base-info.email": "邮箱",
  "CustomerManagement.base-info.phone": "手机号",
  "CustomerManagement.base-info.gender": "客户性别",
  "CustomerManagement.base-info.gender.female": "女",
  "CustomerManagement.base-info.gender.male": "男",
  "CustomerManagement.base-info.gender.unknown": "未知",
  "CustomerManagement.base-info.language": "语言",
  "CustomerManagement.base-info.province": "所在省份",
  "CustomerManagement.base-info.register-time": "注册时间",
  "CustomerManagement.base-info.source": "数据来源",
  "CustomerManagement.base-info.source.1": "用户创建",
  "CustomerManagement.base-info.source.2": "接口导入",
  "CustomerManagement.base-info.storefront-name": "店铺名称",
  "CustomerManagement.behavior-records": "客户行为记录",
  "CustomerManagement.behavior-records.behavior-type": "事件筛选",
  "CustomerManagement.behavior-records.record-end-time": "记录结束时间",
  "CustomerManagement.behavior-records.record-start-time": "记录开始时间",
  "CustomerManagement.block-list": "黑名单",
  "CustomerManagement.block-list.block-list-status": "黑名单状态",
  "CustomerManagement.block-list.block-list-status.on-block-list": "黑名单用户",
  "CustomerManagement.block-list.filter.end_time": "结束时间",
  "CustomerManagement.block-list.filter.keyword": "请输入关键词",
  "CustomerManagement.block-list.filter.start_time": "开始时间",
  "CustomerManagement.block-list.import": "导入",
  "CustomerManagement.block-list.import-block-list": "导入黑名单",
  "CustomerManagement.block-list.import-block-list.download-template":
    "下载黑名单模板",
  "CustomerManagement.block-list.import-block-list.msg":
    "正在导入，请稍后查看历史导入记录获取详细报告",
  "CustomerManagement.block-list.import-block-list.option-0":
    "更新已有的黑名单记录",
  "CustomerManagement.block-list.import-block-list.option-1":
    "跳过已有的黑名单记录",
  "CustomerManagement.block-list.import-block-list.select-file": "选择文件",
  "CustomerManagement.block-list.import-block-list.start": "开始导入",
  "CustomerManagement.block-list.import-block-list.tips":
    "请上传符合导入模板格式的文件，文件需要小于10M",
  "CustomerManagement.block-list.import-record": "导入记录",
  "CustomerManagement.block-list.import-record.table.import-result": "导入结果",
  "CustomerManagement.block-list.import-record.table.import-result.failure":
    "{failure_count}项目失败",
  "CustomerManagement.block-list.import-record.table.import-result.pending":
    "导入中",
  "CustomerManagement.block-list.import-record.table.import-result.success":
    "{success_count}项目成功",
  "CustomerManagement.block-list.import-record.table.import-time": "导入时间",
  "CustomerManagement.block-list.import-record.table.operation": "操作",
  "CustomerManagement.block-list.import-record.table.operation.download":
    "下载报告",
  "CustomerManagement.block-list.import-record.table.operator": "操作人",
  "CustomerManagement.block-list.import-record.title": "黑名单导入记录",
  "CustomerManagement.block-list.restrictions-on-blocklist": "黑名单限制",
  "CustomerManagement.block-list.restrictions-on-blocklist.login":
    "禁止注册/登录",
  "CustomerManagement.block-list.restrictions-on-blocklist.order":
    "允许登录但禁止创建订单",
  "CustomerManagement.block-list.table.affected-users": "影响用户",
  "CustomerManagement.block-list.table.affected-users.tooltips":
    "受影响用户数量统计在导入黑名单完成后更新，且每天早上1点更新。",
  "CustomerManagement.block-list.table.description": "描述",
  "CustomerManagement.block-list.table.identifier": "黑名单标识",
  "CustomerManagement.block-list.table.operation": "操作",
  "CustomerManagement.block-list.table.remove": "移除",
  "CustomerManagement.block-list.table.remove.tips": "确定将该数据移出黑名单？",
  "CustomerManagement.block-list.table.update-time": "更新时间",
  "CustomerManagement.block-list.upload-file-msg.failed": "文件上传失败",
  "CustomerManagement.block-list.upload-file-msg.limit": "请上传符合要求的文件",
  "CustomerManagement.consent": "授权记录",
  "CustomerManagement.consent.activity.accept.agreement_title": "同意签署条例",
  "CustomerManagement.consent.activity.accept.scope": "同意授权Scope：",
  "CustomerManagement.consent.activity.accept.title": "客户同意授权",
  "CustomerManagement.consent.activity.deny.agreement_title": "拒绝签署条例",
  "CustomerManagement.consent.activity.deny.scope": "拒绝授权Scope：",
  "CustomerManagement.consent.activity.deny.title": "客户拒绝授权",
  "CustomerManagement.consent.activity.revoke.scope": "取消授权Scope：",
  "CustomerManagement.consent.activity.revoke.title": "客户取消授权",
  "CustomerManagement.consent.scope.PII-Basic":
    "客户昵称、客户性别、客户手机号、所在国家、所在省、所在市、收藏记录、浏览记录、收件地址、订单信息",
  "CustomerManagement.default-address": "【默认地址】",
  "CustomerManagement.filter.channel-name": "注册店铺",
  "CustomerManagement.filter.channel-type": "注册渠道",
  "CustomerManagement.filter.end-date": "结束日期",
  "CustomerManagement.filter.start-date": "开始日期",
  "CustomerManagement.filter.keyword": "请输入关键字",
  "CustomerManagement.filter.keyword.placeholder":
    "客户ID，客户姓名，客户手机/邮箱可搜索。ID搜索需输入完整信息。",
  "CustomerManagement.order-list": "订单列表",
  "CustomerManagement.receiver-address": "收货人地址",
  "CustomerManagement.receiver-name": "收货人姓名",
  "CustomerManagement.receiver-phone": "收货人手机",
  "CustomerManagement.record-count": "共计{count}条记录",
  "CustomerManagement.table.avatar": "头像",
  "CustomerManagement.table.blocked": "黑名单状态",
  "CustomerManagement.table.blocked.false": "非黑名单用户",
  "CustomerManagement.table.blocked.true": "黑名单用户",
  "CustomerManagement.table.channel-name": "注册渠道",
  "CustomerManagement.table.id": "客户ID",
  "CustomerManagement.table.nickname": "客户名称",
  "CustomerManagement.table.phone": "客户手机",
  "CustomerManagement.table.register-time": "注册时间",
  "CustomerManagement.table.serial-number": "序号",
  "CustomerManagement.table.storefront-name": "注册店铺",
  "CustomerManagement.title": "客户",
  "CustomerManagement.close-customer-account.button": "注销客户",
  "CustomerManagement.close-customer-account.modal.1.title": "注销客户",
  "CustomerManagement.close-customer-account.modal.1.content.row1":
    "注销客户将删除所有客户的标识性信息，包括但不限于客户的姓名，账号，收货地址等信息\n请与客户核实后，进行注销操作。",
  "CustomerManagement.close-customer-account.modal.1.content.row2":
    "如需继续完成注销操作，请点击确认。",
  "CustomerManagement.close-customer-account.modal.2.file.tips.row1":
    "1.最多添加3张图片凭证,",
  "CustomerManagement.close-customer-account.modal.2.file.tips.row2":
    "2.图片大小最多不超5M",
  "CustomerManagement.close-customer-account.modal.2.file.tips.row3":
    "3.支持图片格式：bmp、jpg、jpeg、png、gif、svg、tiff 添加图片链接",
  "CustomerManagement.close-customer-account.modal.2.file.tips.row4":
    "4.仅支持添加白名单域名下的图片链接",
  "CustomerManagement.close-customer-account.modal.2.reason": "注销原因",
  "CustomerManagement.close-customer-account.modal.2.reason.placeholder":
    "请输入注销原因",
  "CustomerManagement.close-customer-account.modal.2.evidence": "上传注销凭证",
  "CustomerManagement.close-customer-account.modal.2.evidence.option.0":
    "使用文件上传",
  "CustomerManagement.close-customer-account.modal.2.evidence.option.1":
    "使用链接上传",
  "CustomerManagement.close-customer-account.modal.2.notification.tips.valid":
    "该账号所属店铺已开启 注销成功 事件通知，注销完成将发送短信/邮件",
  "CustomerManagement.close-customer-account.modal.2.notification.tips.permision-error":
    "权限不足，无法查询通知配置状态",
  "CustomerManagement.close-customer-account.modal.2.notification.tips.invalid":
    "该账号所属店铺未开启 注销成功 事件通知，注销完成将无法发送短信/邮件。请前往 {link} 完成相关配置",
  "CustomerManagement.close-customer-account.modal.2.notification.tips.invalid.link":
    "店铺通知",
  "CustomerManagement.social-identifier": "社交身份",
  "CustomerManagement.social-identifier.storefront": "社交渠道",
  "CustomerManagement.social-identifier.open_id": "Open ID",
  "CustomerManagement.social-identifier.union_id": "Union ID",
  "Download.export-modal.default.info":
    "为了给您提供更好的查询性能以及体验，我们对导出功能进行了改进：",
  "Download.export-modal.default.tips": [
    "为了保证您的导出性能，导出的数据需要在【下载中心】获取；",
    "为了保证您的导出性能，两次导出的时间间隔请保持在5分钟以上。",
  ],
  "Download.export-modal.default.title": "导出报告",
  "Download.export.origin.type.enum": {
    LOGIN_LOG: "登录日志报表",
    OPERATION_LOG: "操作日志报表",
    ORDER: "订单报表",
  },
  "Download.export.status.enum": {
    FAILED: "生成失败",
    GENERATION: "生成中",
    SUCCESS: "已生成",
  },
  "Download.list.column.header.create_time": "报表创建时间",
  "Download.list.column.header.name": "报表名称",
  "Download.list.column.header.operation.download": "下载",
  "Download.list.column.header.operation.refresh": "刷新",
  "Download.list.column.header.operation.regenerate": "重新生成",
  "Download.list.column.header.status": "状态",
  "Download.list.column.header.type": "报表类型",
  "Download.list.title": "下载列表",
  "Download.management.info":
    "为保护数据安全，只能查看当前登录账号下载的报表明细；报表数据仅保留24小时，超时后将自动清除。",
  "Download.management.title": "下载中心",
  "Download.operation.frequently.tip": "操作频繁，请稍后再试",
  "Download.operation.success.content":
    "导出操作成功，请到【下载中心】中查看导出数据。",
  "Download.operation.success.title": "操作成功",
  "Download.title": "下载",
  "Global.Component.Combobox.placeholder": "请选择",
  "Global.Component.ConditionTable.FilterBar.title": "筛选",
  "Global.Component.DuelingPickList.selected": "已选择",
  "Global.Component.DuelingPickList.unselected": "未选择",
  "Global.Component.Editor.Modal.images": "图片",
  "Global.Component.Editor.Modal.title": "插入图片",
  "Global.Component.Editor.Variable.label": "插入变量",
  "Global.Component.Upload.maxLength.valid":
    "上传失败，文件大小大于{maxSize}M，请重新上传",
  "Global.Component.Upload.operation.success": "上传成功",
  "Global.Component.Upload.path.file": "使用文件上传",
  "Global.Component.Upload.path.link": "使用链接上传",
  "Global.Component.Upload.video.transcode-failed": "转码失败",
  "Global.Component.Upload.video.transcoding": "转码中...",
  "Global.Component.filter.create_at": "创建时间",
  "Global.Component.upload.image.max-out": "最多只能上传{maxLength}张图片",
  "Global.Components.Divider.noMore": "暂无更多",
  "Global.Components.Form.ComboboxControl.noOptionsFound": "无匹配选项",
  "Global.Components.Form.DefaultErrorText.maxLength":
    "请输入长度小于等于{maxLength}的字符",
  "Global.Components.Form.DefaultErrorText.minLength":
    "请输入长度大于等于{minLength}的字符",
  "Global.Components.Form.DefaultErrorText.require": "此项不能为空",
  "Global.Components.InitialContainer.empty": "暂无数据",
  "Global.Components.InitialContainer.error.btnName": "重新获取",
  "Global.Components.InitialContainer.error.msg": "获取失败",
  "Global.Components.Prompt.button.confirm": "确定",
  "Global.Components.Prompt.desc": "离开当前页面数据不会被保存。确认离开吗？",
  "Global.Components.Prompt.prevent.delete": "是否删除该条数据: {name}",
  "Global.Components.Prompt.title": "系统提醒",
  "Global.Components.StepWrapper.done.defaultFailed":
    "当前步骤未完成，请完成当前操作再进行下一步",
  "Global.Components.StepWrapper.done.defaultFailed.Final": "当前步骤未完成",
  "Global.Components.StepWrapper.footer.cancel": "取消",
  "Global.Components.StepWrapper.footer.next": "下一步",
  "Global.Components.StepWrapper.footer.prev": "上一步",
  "Global.Components.StepWrapper.header.title": "步骤{number}：",
  "Global.Components.Stepper.button.cancel": "取消",
  "Global.Components.Stepper.button.commit": "保存",
  "Global.Components.Stepper.button.next": "下一步",
  "Global.Components.Stepper.button.prev": "上一步",
  "Global.action.copy.failed": "复制失败",
  "Global.action.copy.success": "复制成功",
  "Global.add": "创建",
  "Global.add-one": "添加",
  "Global.apply": "应用",
  "Global.back": "返回",
  "Global.cancel": "取消",
  "Global.close": "关闭",
  "Global.confirm": "确认",
  "Global.copy": "复制",
  "Global.delete": "删除",
  "Global.edit": "编辑",
  "Global.empty": "暂无数据",
  "Global.export": "导出",
  "Global.finish": "完成",
  "Global.header.apps.switch.no-ssm-asset":
    "该Org无法使用 社交营销，请与您的管理员确认是否完成购买或续费。",
  "Global.header.icons.title": {
    "download-center": "下载中心",
    "help-center": "帮助中心",
    settings: "设置",
  },
  "Global.header.settings.popover": {
    "commerce-settings": "社交电商",
    "messaging-settings": "社交营销",
    organization: "组织",
    "storefront-notification": "店铺通知配置-SMS配置",
    tableau: "Tableau Server",
  },
  "Global.layout.account.settings": "账号设置",
  "Global.layout.help-center": "帮助中心",
  "Global.layout.logout": "退出登录",
  "Global.layout.logout.content": "确认退出登录吗？",
  "Global.layout.logout.title": "退出登录",
  "Global.layout.other-options": "其他选项",
  "Global.layout.switch-tenant": "切换组织",
  "Global.layout.user-center": "个人中心",
  "Global.load-more": "加载更多",
  "Global.menus.extra.log-audit": "审计",
  "Global.message.operation.create.success": "创建成功",
  "Global.message.operation.delete.success": "删除成功",
  "Global.message.operation.disable.success": "禁用成功",
  "Global.message.operation.enable.success": "启用成功",
  "Global.message.operation.success": "操作成功",
  "Global.message.operation.update.success": "更新成功",
  "Global.miniprogram": "微信小程序",
  "Global.no-cover": "暂无封面",
  "Global.no-resource": "暂无资源",
  "Global.number_0": "零",
  "Global.number_1": "一",
  "Global.number_10": "十",
  "Global.number_2": "二",
  "Global.number_3": "三",
  "Global.number_4": "四",
  "Global.number_5": "五",
  "Global.number_6": "六",
  "Global.number_7": "七",
  "Global.number_8": "八",
  "Global.number_9": "九",
  "Global.ok": "确定",
  "Global.operation": "操作",
  "Global.other": "其他",
  "Global.page-not-found": "找不到页面",
  "Global.page-not-found-sub_msg": "请检查网址和重定向到正确的位置",
  "Global.phone-number": "手机号",
  "Global.pii.control.hide": "隐藏隐私信息",
  "Global.pii.control.show": "显示完整信息",
  "Global.preview": "预览",
  "Global.refresh": "刷新",
  "Global.reset": "重置",
  "Global.retry": "重试",
  "Global.save": "保存",
  "Global.search": "查询",
  "Global.see-detail": "查看详情",
  "Global.settings": "设置",
  "Global.submit": "提交",
  "Global.system-warning": "系统提醒",
  "Global.total-num": "{num}个项目",
  "Global.unknown-resource": "未知URL",
  "Global.updatedAt": "更新时间",
  "Global.updatedBy": "更新人",
  "Global.verify": "校验",
  "Global.web": "网站",
  "Integration.demandware.basic.configuration.invalid": "配置失效",
  "Integration.demandware.basic.configuration.patch.modal.confirm":
    "校验并保存",
  "Integration.demandware.basic.configuration.patch.modal.form.api-version":
    "API版本",
  "Integration.demandware.basic.configuration.patch.modal.form.api-version.placeholder":
    "请输入API版本号，最大长度10",
  "Integration.demandware.basic.configuration.patch.modal.form.client-id":
    "ocApi-Client_ID",
  "Integration.demandware.basic.configuration.patch.modal.form.client-id.placeholder":
    "请输入ocApi-Client_ID， 最大长度100",
  "Integration.demandware.basic.configuration.patch.modal.form.client-pass":
    "ocApi-Client_password",
  "Integration.demandware.basic.configuration.patch.modal.form.client-pass.placeholder":
    "请输入ocApi-Client_password，最大长度100",
  "Integration.demandware.basic.configuration.patch.modal.form.hostname":
    "Https主机名",
  "Integration.demandware.basic.configuration.patch.modal.form.hostname.placeholder":
    "请输入Https主机名，最大长度200",
  "Integration.demandware.basic.configuration.patch.modal.form.site-id":
    "Storefront站点ID",
  "Integration.demandware.basic.configuration.patch.modal.form.site-id.placeholder":
    "请输入Storefront站点ID，最大长度50",
  "Integration.demandware.basic.configuration.title": "B2C电商配置",
  "Integration.demandware.basic.configuration.valid": "配置有效",
  "Integration.demandware.configuration.without-keypairs.help":
    "请先配置密钥对",
  "Integration.demandware.help-info":
    "请配置具备Write权限的B2C Commerce API key pairs , 更多信息,请查阅",
  "Integration.demandware.help-info.link": "用户指南。",
  "Integration.demandware.sync.object.customer": "客户",
  "Integration.demandware.sync.object.order": "订单",
  "Integration.demandware.sync.object.product": "商品",
  "Integration.demandware.sync.status.disable": "禁用",
  "Integration.demandware.sync.status.disabling": "禁用中",
  "Integration.demandware.sync.status.enable": "启用",
  "Integration.demandware.sync.type.cycle": "周期同步",
  "Integration.demandware.sync.type.once": "单次同步",
  "Integration.demandware.task.basic-info.title": "基础信息",
  "Integration.demandware.task.create": "创建同步任务",
  "Integration.demandware.task.create.title": "创建同步任务",
  "Integration.demandware.task.detail.info.title": "任务信息",
  "Integration.demandware.task.detail.report.table.column.operation.download":
    "下载报告",
  "Integration.demandware.task.detail.report.table.column.result": "结果",
  "Integration.demandware.task.detail.report.table.column.result.failed":
    "个项目失败",
  "Integration.demandware.task.detail.report.table.column.result.success":
    "个项目成功",
  "Integration.demandware.task.detail.report.table.column.sync-time":
    "同步时间",
  "Integration.demandware.task.detail.report.title": "同步任务报告",
  "Integration.demandware.task.detail.title": "任务详情",
  "Integration.demandware.task.form.basic-info.description": "描述",
  "Integration.demandware.task.form.basic-info.description.placeholder":
    "请输入描述, 最大长度1000",
  "Integration.demandware.task.form.basic-info.name": "任务名称",
  "Integration.demandware.task.form.basic-info.name.placeholder":
    "请输入任务名称, 最大长度200",
  "Integration.demandware.task.form.basic-info.object": "对象",
  "Integration.demandware.task.form.basic-info.object.placeholder":
    "请选择同步对象",
  "Integration.demandware.task.form.settings.catalog": "商品目录",
  "Integration.demandware.task.form.settings.catalog.placeholder":
    "请选择商品目录",
  "Integration.demandware.task.form.settings.currency": "货币类型",
  "Integration.demandware.task.form.settings.currency.tooltip":
    "货币将获取Storefront Site ID 的默认货币。在商品同步时，商品价格将获取该商品定义的PriceBook中该货币单位的最低价格。",
  "Integration.demandware.task.form.settings.end-time": "结束时间",
  "Integration.demandware.task.form.settings.end-time.placeholder":
    "请选择结束时间",
  "Integration.demandware.task.form.settings.field-mapping":
    "字段映射（通过逐个字段的勾选，Demandware字段将其映射到Social Commerce字段）",
  "Integration.demandware.task.form.settings.field-mapping.action.add":
    "添加到映射清单",
  "Integration.demandware.task.form.settings.field-mapping.source.action.add":
    "添加自定义字段",
  "Integration.demandware.task.form.settings.field-mapping.source.added":
    "已添加",
  "Integration.demandware.task.form.settings.field-mapping.source.empty":
    "当前区域语言下暂无字段",
  "Integration.demandware.task.form.settings.field-mapping.source.search":
    "请输入字段名称",
  "Integration.demandware.task.form.settings.field-mapping.source.title":
    "数据源：B2C Commerce 字段",
  "Integration.demandware.task.form.settings.field-mapping.target.title":
    "目标：Social Commerce 字段",
  "Integration.demandware.task.form.settings.field-mapping.valid.required":
    "请为Social Commerce的必填字段添加映射关系",
  "Integration.demandware.task.form.settings.image-root": "图片根目录",
  "Integration.demandware.task.form.settings.image-root.placeholder":
    "请选择图片根目录",
  "Integration.demandware.task.form.settings.view-type": "查看类型",
  "Integration.demandware.task.form.settings.view-type.input.placeholder":
    "请输入查看类型，最大长度50",
  "Integration.demandware.task.form.settings.inventory-list": "库存清单ID",
  "Integration.demandware.task.form.settings.inventory-list.placeholder":
    "请选择库存清单ID",
  "Integration.demandware.task.form.settings.locale": "区域语言",
  "Integration.demandware.task.form.settings.locale.placeholder":
    "请选择区域语言",
  "Integration.demandware.task.form.settings.site-id": "Storefront站点ID",
  "Integration.demandware.task.form.settings.site-id.placeholder":
    "请选择Storefront站点ID",
  "Integration.demandware.task.form.settings.start-time": "开始时间",
  "Integration.demandware.task.form.settings.start-time.placeholder":
    "请选择开始时间",
  "Integration.demandware.task.form.settings.sync-type": "同步类型",
  "Integration.demandware.task.form.settings.sync-type.going": "周期同步",
  "Integration.demandware.task.form.settings.sync-type.going.cycle":
    "任务周期（Mins / Cycle）",
  "Integration.demandware.task.form.settings.sync-type.going.cycle.placeholder":
    "不超过一周（10080）分钟",
  "Integration.demandware.task.form.settings.sync-type.going.cycle.tooltip":
    "周期时间只支持整数min作为时间间隔，每当一个同步任务结束，将等待一个周期间隔，再重新开始新一轮的任务同步，直到结束时间，任务将不再循环。",
  "Integration.demandware.task.form.settings.sync-type.time": "单次同步",
  "Integration.demandware.task.mapping-list.column.operation.system":
    "系统生成",
  "Integration.demandware.task.mapping-list.column.operation.title": "操作",
  "Integration.demandware.task.mapping-list.column.source.title": "数据源",
  "Integration.demandware.task.mapping-list.column.target.title": "目标",
  "Integration.demandware.task.mapping-list.title": "映射清单",
  "Integration.demandware.task.settings.title": "任务设置",
  "Integration.demandware.task.table.column.name": "任务名称",
  "Integration.demandware.task.table.column.object": "对象",
  "Integration.demandware.task.table.column.operator": "更新人",
  "Integration.demandware.task.table.column.site-id": "Storefront站点ID",
  "Integration.demandware.task.table.column.status": "状态",
  "Integration.demandware.task.table.column.sync-type": "同步类型",
  "Integration.demandware.task.table.column.update-at": "更新时间",
  "Integration.demandware.task.table.operation.enable.prevent":
    "为了防止数据冲突，同一对象的只能有一个任务处于“启用”状态。请在启用此任务之前先禁用其他“产品”任务。",
  "Integration.demandware.task.title": "同步任务",
  "Integration.demandware.task.update.title": "更新同步任务",
  "Integration.demandware.title": "B2C电商同步",
  "Integration.title": "电商集成",
  "Notification.SMSConfig.title": "SMS配置",
  "Notification.addSign.confirm-btn": "提交校验",
  "Notification.addSign.fail": "添加失败",
  "Notification.addSign.inlineHelp": "请粘贴已在阿里云审核通过的短信签名",
  "Notification.addSign.label": "签名",
  "Notification.addSign.legal.isv.SMS_SIGNATURE_ILLEGAL":
    "签名不存在或者已加入黑名单",
  "Notification.addSign.legal.isv.SMS_SIGN_ILLEGAL": "签名禁止使用",
  "Notification.addSign.placeholder": "长度限2-12字符",
  "Notification.addSign.rules.required": "请输入签名",
  "Notification.addSign.tips": "请粘贴已在阿里云审核通过的短信签名",
  "Notification.addSign.title": "创建签名",
  "Notification.bindEvent.email.template_content": "邮件内容",
  "Notification.bindEvent.email.template_name": "邮件主题",
  "Notification.bindEvent.email.template_name.placeholder": "请输入邮件主题",
  "Notification.bindEvent.sms.preview": "效果预览",
  "Notification.bindEvent.sms.sign": "选择短信签名",
  "Notification.bindEvent.sms.sign.placeholder": "请选择短信签名",
  "Notification.bindEvent.sms.template": "选择短信模板",
  "Notification.bindEvent.sms.template.placeholder": "请选择短信模板",
  "Notification.bindEvent.wx.preview": "效果预览",
  "Notification.bindEvent.wx.template": "微信消息模板",
  "Notification.bindEvent.wx.template.placeholder": "请选择微信消息模板",
  "Notification.deleteSign.content":
    "删除签名将影响相应事件的短信通知，请确认是否删除!",
  "Notification.deleteSign.title": "删除签名",
  "Notification.deleteTemplate.content":
    "删除该模板将同步删除阿里云SMS的短信模板将影响相应事件的短信通知，是否确认删除？",
  "Notification.deleteTemplate.title": "删除短信模板",
  "Notification.disableEvent.content": "是否停用该通知渠道？",
  "Notification.disableEvent.title": "停用通知渠道",
  "Notification.edit-notice.title.email": "邮件通知配置",
  "Notification.edit-notice.title.sms": "SMS通知配置",
  "Notification.edit-notice.title.wx": "微信小程序通知配置",
  "Notification.edit-template.eventType": "事件类型",
  "Notification.edit-template.eventType.placeholder": "请选择事件类型",
  "Notification.edit-template.legal.isv.SMS_TEMPLATE_ILLEGAL":
    "短信模板不存在或者已加入黑名单",
  "Notification.edit-template.remark": "申请说明",
  "Notification.edit-template.remark.placeholder":
    "请描述详细的使用场景，并提供产品链接、APP、公众号、公司标准全称等，例如：使用场景：向客户推送XX系统的短信验证码通知。",
  "Notification.edit-template.remark.rule.maxLength":
    "申请说明不得超过100个字符",
  "Notification.edit-template.remark.rule.required": "请输入申请说明",
  "Notification.edit-template.remark.tips":
    "预计2小时完成审核，审核工作时间：北京时间周一至周日 9：00-23：00（法定节日顺延）。",
  "Notification.edit-template.submit": "提交",
  "Notification.edit-template.templateContent": "模板内容",
  "Notification.edit-template.templateContent.placeholder":
    "变量格式${name}; 示例：尊敬的${name}，您的订单${Order.ID}已经支付成功。",
  "Notification.edit-template.templateContent.rule.maxLength":
    "模板内容不得超过500个字符",
  "Notification.edit-template.templateContent.rule.required": "请输入模板内容",
  "Notification.edit-template.templateContent.tips.1":
    "1.短信字数含“签名+模板内容+变量内容”，短信70个字数含以内，按1条短信计费；超出70个字为长短信，按照67个字数记为1条短信费用。",
  "Notification.edit-template.templateContent.tips.2":
    "2.不能发送营销/贷款/借款/中奖/抽奖类短信，不支持金融理财&房产通知类短信（验证码除外）",
  "Notification.edit-template.templateContent.tips.3":
    "3.签名/模板申请规范{link}",
  "Notification.edit-template.templateName": "模板名称",
  "Notification.edit-template.templateName.placeholder":
    "请输入名称，不超过30个字符",
  "Notification.edit-template.templateName.rule.maxLength":
    "名称不得超过30个字符",
  "Notification.edit-template.templateName.rule.required": "请输入名称",
  "Notification.edit-template.templateType": "短信类型",
  "Notification.edit-template.templateType.0": "验证码",
  "Notification.edit-template.templateType.1": "短信通知",
  "Notification.edit-template.templateType.2": "推广短信",
  "Notification.edit-template.templateType.3": "国际/港澳台消息",
  "Notification.edit-template.templateType.placeholder": "请选择短信类型",
  "Notification.edit-template.title.add": "创建模板",
  "Notification.edit-template.title.edit": "编辑模板",
  "Notification.edit-template.title.see-detail": "查看模板",
  "Notification.email-config.form.email_type": "邮件发送方式",
  "Notification.email-config.form.host": "SMTP服务器",
  "Notification.email-config.form.password": "SMTP密码",
  "Notification.email-config.form.port": "SMTP端口",
  "Notification.email-config.form.port.tooltip": "请勿使用端口25",
  "Notification.email-config.form.port.validate": "请输入1～65535内的端口号",
  "Notification.email-config.form.sender_email_addr": "发件人邮箱",
  "Notification.email-config.form.username": "SMTP用户名",
  "Notification.email-config.form.validate_type": "SMTP验证方式",
  "Notification.email-config.notification.1":
    "您需要提供发件邮箱信息并填写SMTP协议所需要的相关参数，更多相关信息，请查看{link}",
  "Notification.email-config.notification.2": "用户指南",
  "Notification.email-config.testEmail.label":
    "您可以发送测试邮件校验当前的SMTP配置是否生效",
  "Notification.email-config.testEmail.placeholder": "请输入收件邮箱",
  "Notification.email-config.testEmail.submitter": "发送测试邮件",
  "Notification.emailConfig.title": "邮件配置",
  "Notification.enableEvent.content": "是否启用该通知渠道？",
  "Notification.enableEvent.title": "启用通知渠道",
  "Notification.event.no-sms-sign": "请前往SMS配置的签名管理进行配置",
  "Notification.event.no-sms-sign-tmpl":
    "请前往SMS配置的签名管理或模板管理进行配置",
  "Notification.event.no-sms-sign-tmpl.action": "去配置",
  "Notification.event.no-sms-sign.tip": "没有生效的短信签名",
  "Notification.event.no-sms-tmpl": "请前往SMS配置的模板管理进行配置",
  "Notification.event.no-sms-tmpl.tip": "该事件没有生效的短信模板",
  "Notification.event.not-email-config":
    "请前往邮件配置页面，完成以下操作，才能为该事件开通邮件通知。",
  "Notification.event.not-email-config.tip": "配置SMTP参数",
  "Notification.event.not-sms-account":
    "请前往SMS配置页面，完成以下操作，才能为该事件开通短信通知。",
  "Notification.event.not-sms-account.tip1": "配置SMS账号",
  "Notification.event.not-sms-account.tip2": "添加短信签名",
  "Notification.event.not-sms-account.tip3": "添加短信模板",
  "Notification.notice.details":
    "Salesforce Social Commerce 为您准备的客户消息通知。您可以在此页面管理每个事件的通知方式，在使用SMS之前，您需要先进行SMS配置",
  "Notification.notice.title": "店铺通知配置",
  "Notification.sms-account.info":
    "Salesforce Social Commerce 为您对接了阿里云SMS，请前往开通阿里云SMS账号，并填写相关参数进行绑定，更多相关信息，请查看 {link}",
  "Notification.sms-account.info.link": "用户指南",
  "Notification.sms-account.submit.button": "提交校验",
  "Notification.sms-account.submit.validate.error":
    "接口校验失败，请填写正确的参数",
  "Notification.sms-account.submit.validate.success.prompt.content":
    "AccessKey ID：{accountID}",
  "Notification.sms-account.submit.validate.success.prompt.finish": "完成",
  "Notification.sms-account.submit.validate.success.prompt.title":
    "关联SMS账号",
  "Notification.sms-account.submit.validate.success.toast":
    "校验通过，已对接SMS账号",
  "Notification.sms-account.tip-modal.confirm": "继续编辑",
  "Notification.sms-account.tip-modal.content":
    "修改SMS账号将导致签名、模板全部清空，并初始化您的店铺通知配置，该操作不可逆，请确认是否继续修改？",
  "Notification.sms-account.tip-modal.title": "编辑SMS账号",
  "Notification.sms-account.unbind.text": "未绑定SMS账户，请点击编辑，完成绑定",
  "Notification.sms-accounts.tab-title": "SMS账号",
  "Notification.sms-config.ali.modal.confirm": "提交",
  "Notification.sms-config.ali.modal.event.info":
    "请先选择事件，再粘贴短信模板CODE到下方输入框，我们将校验该模板是否匹配此事件所提供的参数及短信类型。校验通过即可添加成功。",
  "Notification.sms-config.ali.modal.form.label.tmpl-code": "模板Code",
  "Notification.sms-config.ali.modal.form.label.tmpl-code.suffix": "提交校验",
  "Notification.sms-config.ali.modal.form.label.tmpl-code.validate.failed":
    "校验失败",
  "Notification.sms-config.ali.modal.form.label.tmpl-code.validate.success":
    "校验成功",
  "Notification.sms-config.ali.modal.form.label.tmpl-content.action":
    "更换变量",
  "Notification.sms-config.ali.modal.form.label.tmpl-content.validate.failed":
    "该模板含有无法识别的变量，请更换为该事件的关联变量",
  "Notification.sms-config.ali.modal.info":
    '您可以登录阿里云短信服务控制台，选择国内消息或国际/港澳台消息，在模板管理页签中可查看模板Code。您也可以通过阿里云的"AddSmsTemplate"接口获取模板Code。',
  "Notification.sms-config.ali.variable.modal.form.label.placeholder":
    "请选择一个变量",
  "Notification.sms-config.ali.variable.modal.form.label.suffix": "替换为",
  "Notification.sms-config.btn.add": "创建新模板",
  "Notification.sms-config.btn.add.eld-tmpl": "获取旧模板",
  "Notification.sms-config.tab-title": "签名管理",
  "Notification.sms-config.table.created-at": "创建时间",
  "Notification.sms-config.table.event-name": "事件名称",
  "Notification.sms-config.table.event-type": "事件类型",
  "Notification.sms-config.table.eventName.CONSUMER_CREATE_ORDER": "创建订单",
  "Notification.sms-config.table.eventName.CONSUMER_ORDER_DELIVERY_SUCCESS":
    "客户订单已发货",
  "Notification.sms-config.table.eventName.CONSUMER_ORDER_PAY_SUCCESS":
    "客户下单支付成功",
  "Notification.sms-config.table.eventName.CONSUMER_ORDER_TIMEOUT_CANCEL":
    "订单超时取消",
  "Notification.sms-config.table.eventName.CUSTOM_DEACTIVED_ACCOUNT_CODE":
    "账户注销",
  "Notification.sms-config.table.eventName.CUSTOM_FORGET_PASSWORD_CODE":
    "忘记密码",
  "Notification.sms-config.table.eventName.CUSTOM_LOGIN_CODE": "登录",
  "Notification.sms-config.table.eventName.CUSTOM_REGISTRATION_CODE": "注册",
  "Notification.sms-config.table.serial-number": "序号",
  "Notification.sms-config.table.sign-name": "签名名称",
  "Notification.sms-config.table.sign-status": "审核状态",
  "Notification.sms-config.table.template-name": "模板名称",
  "Notification.sms-config.table.template-status": "审核状态",
  "Notification.status.0": "审核中",
  "Notification.status.1": "已过审",
  "Notification.status.10": "外部已撤回",
  "Notification.status.2": "审核不通过",
  "Notification.status.3": "平台已删除",
  "Notification.status.4": "外部已删除",
  "Notification.store.type.title.placeholder": "请选择店铺",
  "Notification.store.type.title.web": "网站",
  "Notification.store.type.title.wx": "微信小程序",
  "Notification.store_table.cell.operation.add_notice": "添加通知",
  "Notification.store_table.cell.operation.disable": "停用",
  "Notification.store_table.cell.operation.edit": "编辑",
  "Notification.store_table.cell.operation.enable": "启用",
  "Notification.store_table.cell.operation.previewEmail": "预览邮件",
  "Notification.store_table.cell.operation.previewEmail.prompt.title":
    "预览邮件内容",
  "Notification.store_table.cell.status.disable": "已停用",
  "Notification.store_table.cell.status.enable": "已启用",
  "Notification.store_table.cell.template.emailTitle": "邮件主题：",
  "Notification.store_table.cell.template.nonactivated": "未开通",
  "Notification.store_table.column.event": "事件名称",
  "Notification.store_table.column.notification_channel": "通知方式",
  "Notification.store_table.column.notification_channel.SMS": "SMS",
  "Notification.store_table.column.notification_channel.email": "邮件",
  "Notification.store_table.column.operation": "操作",
  "Notification.store_table.column.serial_number": "序号",
  "Notification.store_table.column.status": "状态",
  "Notification.store_table.column.template": "模板",
  "Notification.store_table.eventName.CONSUMER_CREATE_ORDER": "创建订单",
  "Notification.store_table.eventName.CONSUMER_ORDER_DELIVERY_SUCCESS":
    "客户订单已发货",
  "Notification.store_table.eventName.CONSUMER_ORDER_PAY_SUCCESS":
    "客户下单支付成功",
  "Notification.store_table.eventName.CONSUMER_ORDER_TIMEOUT_CANCEL":
    "订单超时取消",
  "Notification.store_table.eventName.CUSTOM_DEACTIVED_ACCOUNT_CODE":
    "注销账号",
  "Notification.store_table.eventName.CUSTOM_FORGET_PASSWORD_CODE": "忘记密码",
  "Notification.store_table.eventName.CUSTOM_LOGIN_CODE": "验证码登录",
  "Notification.store_table.eventName.CUSTOM_REGISTRATION_CODE": "注册",
  "Notification.store_table.eventName.PRODUCT_ARRIVAL_NOTICE": "到货通知",
  "Notification.store_table.eventName.group.NOTICE_TOPIC_COMMON": "通用",
  "Notification.store_table.eventName.group.NOTICE_TOPIC_VERIFICATION_CODE":
    "验证码",
  "Notification.store_table.eventName.group.event": "事件类型",
  "Notification.store_table.wx.cell.action.webhook": "前往webhook",
  "Notification.store_table.wx.cell.template.active":
    "已启用Webhook，请配合微信模板使用",
  "Notification.store_table.wx.cell.template.in-active":
    "未开通，请前往设置-开启该事件的Webhook",
  "Notification.template.btn.delete": "删除",
  "Notification.template.btn.delete.error.isv.ERROR_TEMPLATE_NOT_DELETE":
    "删除失败",
  "Notification.template.btn.detail": "查看详情",
  "Notification.template.btn.edit": "编辑",
  "Notification.template.tab-title": "模板管理",
  "Notification.title": "通知",
  "Notification.web.title": "网站渠道通知配置",
  "Notification.wx.title": "微信小程序渠道通知配置",
  "Notification.store_table.eventName.DEACTIVED_ACCOUNT_SUCCESS_NOTICE":
    "客户注销通知",
  "Notification.custom-field.title": "自定义字段",
  "Notification.custom-field.send-by-webhook.tooltip":
    "在自定义字段配置中启用‘通过Webhook发送’您就能在Webhook配置中添加与所选事件相关数据表的自定义字段。",
  "OrderManagement.OrderDetail.title": "订单详情",
  "OrderManagement.com.update.success": "更新成功",
  "OrderManagement.delivery-info": "物流信息",
  "OrderManagement.delivery-info.carrier_code": "物流公司编码",
  "OrderManagement.delivery-info.carrier_name": "物流公司名称",
  "OrderManagement.delivery-info.shipping_status": "物流状态",
  "OrderManagement.delivery-info.tracking_number": "物流单号",
  "OrderManagement.discount-detail": "优惠详情",
  "OrderManagement.discount-detail.discount-rule": "优惠规则",
  "OrderManagement.discount-detail.discount_amount": "优惠金额",
  "OrderManagement.discount-detail.participating-products": "参与商品",
  "OrderManagement.discount-detail.participating-products.1": "全场商品参与",
  "OrderManagement.discount-detail.participating-products.2": "部分商品参与",
  "OrderManagement.discount-detail.promotion": "促销",
  "OrderManagement.discount-detail.promotion-name": "促销名称",
  "OrderManagement.discount-detail.promotion-type": "促销类型",
  "OrderManagement.discount-detail.time": "促销时间",
  "OrderManagement.discount-detail.time.end": "结束：{time}",
  "OrderManagement.discount-detail.time.start": "开始：{time}",
  "OrderManagement.filter.channel-name": "渠道名称",
  "OrderManagement.filter.created-date": "订单创建时间",
  "OrderManagement.filter.end-time": "下单结束日期",
  "OrderManagement.filter.header.action.export": "导出",
  "OrderManagement.filter.header.action.export.modal.footer.export.all":
    "导出全部订单列表",
  "OrderManagement.filter.header.action.export.modal.footer.export.part":
    "导出当前订单列表",
  "OrderManagement.filter.header.action.export.modal.info":
    "为了给您提供更好的查询性能以及体验，我们对导出功能进行了改进：",
  "OrderManagement.filter.header.action.export.modal.tip.row1":
    "1. 若需要根据订单筛选条件导出当前订单列表数据，可点击【导出当前订单列表】；若需要导出全部订单数据，可点击【导出全部订单】；",
  "OrderManagement.filter.header.action.export.modal.tip.row2":
    "2. 为了保证您的导出性能，导出的数据需要在【下载中心】获取；",
  "OrderManagement.filter.header.action.export.modal.tip.row3":
    "3. 为了保证您的导出性能，两次导出的时间间隔请保持在5分钟以上。",
  "OrderManagement.filter.header.action.export.modal.title": "订单导出",
  "OrderManagement.filter.order-status": "订单状态",
  "OrderManagement.filter.search-name": "字段查询",
  "OrderManagement.filter.search-value": "请输入要查询的内容",
  "OrderManagement.filter.search.focusTooltip":
    "订单ID，收货人姓名，收货人手机可搜索。ID搜索需输入完整信息。",
  "OrderManagement.filter.start-time": "下单开始日期",
  "OrderManagement.filter.storefront-name": "店铺名称",
  "OrderManagement.order-aftersales-records": "售后记录",
  "OrderManagement.order-info": "订单信息",
  "OrderManagement.order-info.action": "修改订单信息",
  "OrderManagement.order-info.custom-field": "自定义字段",
  "OrderManagement.order-info.custom-message": "买家留言",
  "OrderManagement.order-info.customer.deleted": "客户已注销",
  "OrderManagement.order-info.delivery_address": "收货地址",
  "OrderManagement.order-info.delivery_name": "收货人姓名",
  "OrderManagement.order-info.delivery_phone": "收货人手机",
  "OrderManagement.order-info.discount_amount": "总优惠金额",
  "OrderManagement.order-info.is_gift": "是否为礼物",
  "OrderManagement.order-info.no": "否",
  "OrderManagement.order-info.order-title": "订单信息",
  "OrderManagement.order-info.order_actual_paid_price": "应付总金额",
  "OrderManagement.order-info.payment_actual_paid_price": "实付总金额",
  "OrderManagement.order-info.price-title": "价格信息",
  "OrderManagement.order-info.remark": "订单备注",
  "OrderManagement.order-info.remark.add": "添加",
  "OrderManagement.order-info.remark.add-success": "添加成功",
  "OrderManagement.order-info.remark.add-title": "添加订单备注",
  "OrderManagement.order-info.remark.placeholder": "1-500字符",
  "OrderManagement.order-info.shipping_fee": "运费",
  "OrderManagement.order-info.total_product_price": "商品总额（不含运费）",
  "OrderManagement.order-info.update.addr": "收货省市区",
  "OrderManagement.order-info.update.addr.detail": "收货详细地址",
  "OrderManagement.order-info.update.delivery_phone.valid":
    "请输入有效的电话号码",
  "OrderManagement.order-info.yes": "是",
  "OrderManagement.order-records": "历史记录",
  "OrderManagement.order-status": "订单状态",
  "OrderManagement.order-status-history-records": "收货信息记录",
  "OrderManagement.order-status-records": "订单流转记录",
  "OrderManagement.order-status-records.created_at": "更新时间",
  "OrderManagement.order-status-records.order_status": "订单状态",
  "OrderManagement.order-status.count-down-info": "订单将在 {time} 后自动取消",
  "OrderManagement.order-status.count-down-info.time":
    "{minutesDiff}分钟{secondsDiff}秒",
  "OrderManagement.order-status.status.AUTO_CANCELLED.info":
    "买家超时未支付, 订单自动取消",
  "OrderManagement.order-status.status.CANCELLED_BY_CUSTOMER.info":
    "买家放弃支付，主动取消订单",
  "OrderManagement.order-status.status.CLOSED.info": "交易结束，订单关闭",
  "OrderManagement.order-status.status.COMPLETED.info": "交易成功，订单完成",
  "OrderManagement.order-status.status.WAITING_FOR_CONFIRMED.info":
    "商品已发货，等待买家收货",
  "OrderManagement.order-status.status.WAITING_FOR_DELIVERY.info":
    "买家已付款，等待商家发货",
  "OrderManagement.order-status.status.default.info":
    "该订单状态为下游系统同步状态",
  "OrderManagement.payment-info": "支付信息",
  "OrderManagement.payment-info.payAt": "付款时间",
  "OrderManagement.payment-info.paymentChannel": "付款方式",
  "OrderManagement.payment-info.paymentChannel.ALI_WAP": "支付宝H5支付",
  "OrderManagement.payment-info.paymentChannel.ALI_WEB": "支付宝web支付",
  "OrderManagement.payment-info.paymentChannel.WECHAT_MINI_APP":
    "微信小程序支付",
  "OrderManagement.payment-info.paymentChannel.WECHAT_QRCODE": "微信二维码支付",
  "OrderManagement.payment-info.paymentChannel.WECHAT_WAP": "微信H5支付",
  "OrderManagement.payment-info.paymentChannel.GENERAL": "通用支付",
  "OrderManagement.payment-info.paymentId": "付款单号",
  "OrderManagement.payment-info.paymentStatus.CLOSED": "支付关闭",
  "OrderManagement.payment-info.paymentStatus.FAIL": "支付失败",
  "OrderManagement.payment-info.paymentStatus.FINISHED": "支付完成（不能退款）",
  "OrderManagement.payment-info.paymentStatus.SUCCESS": "支付成功",
  "OrderManagement.payment-info.payment_actual_paid_price": "实付总金额",
  "OrderManagement.payment-info.status": "付款状态",
  "OrderManagement.product-info": "商品信息",
  "OrderManagement.product-info.discount_amount": "优惠金额",
  "OrderManagement.product-info.modal.discount_amount": "优惠金额",
  "OrderManagement.product-info.modal.header": "优惠金额明细",
  "OrderManagement.product-info.modal.promotion_id": "促销ID",
  "OrderManagement.product-info.modal.promotion_name": "促销名称",
  "OrderManagement.product-info.modal.promotion_type": "促销类型",
  "OrderManagement.product-info.modal.promotion_type.1": "满赠",
  "OrderManagement.product-info.modal.promotion_type.2": "满折",
  "OrderManagement.product-info.modal.promotion_type.3": "满减",
  "OrderManagement.product-info.product-list": "商品列表",
  "OrderManagement.product-info.quantity": "购买数量",
  "OrderManagement.product-info.sell_price": "销售价",
  "OrderManagement.product-info.sku_code": "SKU编码",
  "OrderManagement.product-info.sku_id": "SKU ID",
  "OrderManagement.product-info.sku_image": "SKU图片",
  "OrderManagement.product-info.spu_id": "商品ID",
  "OrderManagement.product-info.spu_name": "商品名称",
  "OrderManagement.product-info.spu_name.gift": "赠品",
  "OrderManagement.product-info.variation_attribute_list": "规格",
  "OrderManagement.table.channel_name": "渠道名称",
  "OrderManagement.table.created_at": "下单时间",
  "OrderManagement.table.customer_id": "客户ID",
  "OrderManagement.table.customer_name": "客户名称",
  "OrderManagement.table.customer_phone_number": "客户手机",
  "OrderManagement.table.order_actual_paid_price": "应付总金额",
  "OrderManagement.table.order_id": "订单ID",
  "OrderManagement.table.status": "订单状态",
  "OrderManagement.table.storefront_name": "店铺名称",
  "OrderManagement.table.tracking_number": "物流单号",
  "OrderManagement.title": "订单",
  "OrderManagement.payment-info.paymentChannel.UNION_WEB": "银联 web支付",
  "OrderManagement.payment-info.paymentChannel.UNION_WAP": "银联 H5支付",
  "OrderManagement.list.filter.presale.label": "预售标识",
  "OrderManagement.list.filter.presale.option.presale": "预售订单",
  "OrderManagement.list.filter.presale.option.normal": "普通订单",
  "Product.Gift.create.title": "创建赠品",
  "Product.Gift.delete.failed.modal.title": "商品删除失败",
  "Product.Gift.detail.title": "赠品详情",
  "Product.Gift.disabled.failed.modal.content":
    "参加促销（包含未开始，进行中，已暂停状态）的赠品不允许下架或被删除，请先从促销中移除该赠品。",
  "Product.Gift.disabled.failed.modal.title": "商品下架失败",
  "Product.Gift.edit.title": "编辑赠品",
  "Product.Gift.enabled.failed.modal.title": "商品上架失败",
  "Product.Gift.header.title": "赠品管理",
  "Product.Gift.list.header.notification":
    "赠品是无分类，单规格，默认销售价为0的商品。上架才可以被应用到促销当中，不支持在店铺中被搜索和售卖。",
  "Product.Gift.list.title": "赠品列表",
  "Product.Gift.title": "赠品",
  "Product.NormalProduct.title": "普通商品",
  "Product.Upload.verify-add": "校验并添加",
  "Product.attribute.create.info.row1":
    "1.列表中的属性信息是当前规格库里的所有属性，每个属性都可以关联多个分类。",
  "Product.attribute.create.info.row2":
    "2.删除属性将会使所有分类取消关联该属性，并从属性库中删除该属性，该操作无法恢复。",
  "Product.attribute.info.row1":
    "1.您需要先在分类中关联属性，才能在创建商品时快捷使用该分类下的属性值创建商品。",
  "Product.attribute.info.row2":
    "2.属性可以被多个分类进行关联，若在分类下取消关联属性，不影响已创建的商品。",
  "Product.attribute.modal.delete.info":
    "该属性将会从属性库中删除，删除后不可恢复，且所有分类下都自动取消选择该属性，是否删除？",
  "Product.attribute.status": "属性状态",
  "Product.attribute.status.close": "关闭",
  "Product.attribute.status.info":
    "属性状态影响该属性数据能否在创建商品时使用，已创建成功商品不受影响。",
  "Product.attribute.status.open": "开启",
  "Product.attribute.table.column.operation.cancel-related.info.row1":
    "取消选择该属性，将无法在创建商品过程中使用该属性",
  "Product.attribute.table.column.operation.cancel-related.info.row2": "注意：",
  "Product.attribute.table.column.operation.cancel-related.info.row3":
    "1.如需再次使用该属性，可重新选择属性。",
  "Product.attribute.table.column.operation.cancel-related.info.row4":
    "2.取消选择该属性不会影响已创建的商品。",
  "Product.attribute.value.add": "添加属性值",
  "Product.attribute.value.name.placeholder": "请输入属性值",
  "Product.category.attribute.action": "关联属性",
  "Product.category.attribute.table.column.operation.show-in-channel.close.info":
    "关闭筛选后，客户在渠道中将不能通过该属性进行商品的筛选。",
  "Product.category.attribute.table.column.operation.show-in-channel.open.info":
    "开启筛选后，客户在渠道中将可以通过该属性进行商品的筛选。",
  "Product.category.basic.delete.modal.info": "删除后不可恢复，是否删除？",
  "Product.category.basic.delete.modal.title": "删除分类",
  "Product.category.basic.detail.edit.title": "编辑分类",
  "Product.category.basic.detail.header.last-update": "最后修改日期",
  "Product.category.basic.detail.header.spu-num": "关联商品数",
  "Product.category.basic.detail.header.status": "状态",
  "Product.category.basic.status": "分类状态",
  "Product.category.basic.status.disable": "关闭",
  "Product.category.basic.status.enable": "开启",
  "Product.category.image.upload.tooltip.row1": "最多添加5张分类图片",
  "Product.category.image.upload.tooltip.row2": "上传图片文件",
  "Product.category.image.upload.tooltip.row3": "1.图片大小最多不超5M",
  "Product.category.image.upload.tooltip.row4":
    "2.支持图片格式：bmp、jpg、jpeg、png、gif、svg、tiff",
  "Product.category.image.upload.tooltip.row5": "添加图片链接",
  "Product.category.image.upload.tooltip.row6":
    "请先确保链接的域名已添加到域名白名单内，再添加图片链接",
  "Product.category.prev-cate.tooltip.row1":
    "1.上级分类选项为空时，创建的分类为一级分类。",
  "Product.category.prev-cate.tooltip.row2":
    "2.除一级分类外，其余分类必须选择一个上级分类。",
  "Product.category.spu.create.btn.tooltip":
    "使用该按钮可快捷在当前分类下创建商品，商品创建完成后默认关联在当前分类下。",
  "Product.category.spu.table.column.image.name": "商品主图",
  "Product.category.status.tooltip.row1":
    "1.分类开启：分类可在店铺被获取并展示分类下的商品数据。",
  "Product.category.status.tooltip.row2":
    "2.分类关闭：分类及子分类的数据无法被店铺获取，无法展示分类下的商品数据；创建商品时无法选择状态为关闭的分类作为关联分类。",
  "Product.category.title": "所有分类",
  "Product.category.tooltip.row1":
    "1.商品分类是非常重要的配置，商品都必须被关联至少一个分类，才能通过分类获取创建SKU所用到的规格与属性，所以您需要在商品分类中管理此类商品的规格和属性选项。",
  "Product.category.tooltip.row2":
    "2.商品分类采用无限层级的树状结构关系，最高层级称为一级分类，其子分类称为二级分类，以此类推，我们建议您最多创建三级分类，以防止分类层级过深，不利于前端展示分类列表与查找分类下的商品。",
  "Product.category.tree.drawer.scope-notification": "通过拖拽可改变分类排序",
  "Product.category.tree.sort.action": "排序编辑",
  "Product.category.tree.sort.top": "顶级分类",
  "Product.category.variation.action": "关联规格",
  "Product.category.variation.table.column.operation.show-in-channel.close.info":
    "关闭筛选后，客户在渠道中将不能通过该规格进行商品的筛选。",
  "Product.category.variation.table.column.operation.show-in-channel.open.info":
    "开启筛选后，客户在渠道中将可以通过该规格进行商品的筛选。",
  "Product.classify.btn.confirm": "确定",
  "Product.classify.content.unselect.msg": "您需要选中左侧的分类进行查看与编辑",
  "Product.classify.header.action.btn.add": "创建分类",
  "Product.classify.header.action.btn.delete": "删除当前分类",
  "Product.classify.initial.empty": "暂无商品分类数据，请先创建分类",
  "Product.classify.initial.modal.footer.btn.cancel": "取消",
  "Product.classify.initial.modal.footer.btn.confirm": "保存",
  "Product.classify.tabs.attribute.head.btn.related": "关联属性",
  "Product.classify.tabs.attribute.modal.add": "创建属性",
  "Product.classify.tabs.attribute.modal.add-value": "创建属性值",
  "Product.classify.tabs.attribute.modal.update": "编辑属性",
  "Product.classify.tabs.attribute.modal.update-value": "编辑属性值",
  "Product.classify.tabs.attribute.modal.value.valid.empty": "属性值不能为空",
  "Product.classify.tabs.attribute.modal.value.valid.exist": "该属性值已存在",
  "Product.classify.tabs.attribute.related.table.column.id": "属性ID",
  "Product.classify.tabs.attribute.related.table.column.name": "属性名称",
  "Product.classify.tabs.attribute.related.table.column.placeholder.name":
    "请输入属性名称",
  "Product.classify.tabs.attribute.remove.confirm": "请确认删除属性",
  "Product.classify.tabs.attribute.remove.title": "删除属性",
  "Product.classify.tabs.attribute.table.column.attribute-value": "属性值",
  "Product.classify.tabs.attribute.title": "属性",
  "Product.classify.tabs.attribute.un-related.confirm": "请确认取消关联属性",
  "Product.classify.tabs.attribute.un-related.title": "取消关联属性",
  "Product.classify.tabs.basic.category.remove.confirm": "请确认删除分类",
  "Product.classify.tabs.basic.item.category-name": "分类名称",
  "Product.classify.tabs.basic.item.image": "分类图片",
  "Product.classify.tabs.basic.item.is-toggle-category": "分类是否开启",
  "Product.classify.tabs.basic.item.is-toggle-category.close": "关",
  "Product.classify.tabs.basic.item.is-toggle-category.open": "开",
  "Product.classify.tabs.basic.item.name.validate.name-duplicate":
    "分类名称不能与上级分类同名或同级中已存在该分类",
  "Product.classify.tabs.basic.item.sub-headings": "上级分类",
  "Product.classify.tabs.basic.title": "基本设置",
  "Product.classify.tabs.product.table.column.name": "商品名称",
  "Product.classify.tabs.property.related.table.column.required": "必填",
  "Product.classify.tabs.property.table.column.is-filter": "是否筛选",
  "Product.classify.tabs.property.table.column.operation.un-related":
    "取消关联",
  "Product.classify.tabs.related": "关联成功",
  "Product.classify.tabs.related.title": "关联商品",
  "Product.classify.tabs.table.column.operation.delete.success": "删除成功",
  "Product.classify.tabs.table.column.operation.un-related.confirm.title":
    "商品取消关联",
  "Product.classify.tabs.table.column.operation.un-related.confirm.warning":
    "请确认取消关联商品",
  "Product.classify.tabs.table.column.operation.un-related.success":
    "已取消关联",
  "Product.classify.tabs.variant.head.btn.add": "创建规格",
  "Product.classify.tabs.variant.head.btn.related": "关联规格",
  "Product.classify.tabs.variant.modal.add-value": "创建规格值",
  "Product.classify.tabs.variant.modal.update": "编辑规格",
  "Product.classify.tabs.variant.modal.update-value": "编辑规格值",
  "Product.classify.tabs.variant.modal.value.valid.empty": "规格值不能为空",
  "Product.classify.tabs.variant.modal.value.valid.exist": "该规格值已存在",
  "Product.classify.tabs.variant.related.table.column.id": "规格ID",
  "Product.classify.tabs.variant.related.table.column.name": "规格名称",
  "Product.classify.tabs.variant.related.table.column.placeholder.name":
    "请输入规格名称",
  "Product.classify.tabs.variant.remove.confirm": "请确认删除规格",
  "Product.classify.tabs.variant.remove.title": "删除规格",
  "Product.classify.tabs.variant.table.column.variant-value": "规格值",
  "Product.classify.tabs.variant.title": "规格",
  "Product.classify.tabs.variant.un-related.confirm": "请确认取消关联规格",
  "Product.classify.tabs.variant.un-related.title": "取消关联规格",
  "Product.classify.tip.modal.title": "提示",
  "Product.classify.title": "商品分类",
  "Product.classify.variant.modal.form.name": "名称",
  "Product.classify.variant.modal.form.remark": "备注",
  "Product.classify.variant.modal.form.required": "是否必填",
  "Product.classify.variant.modal.form.required.false": "否",
  "Product.classify.variant.modal.form.required.true": "是",
  "Product.classify.variant.modal.form.status": "状态",
  "Product.classify.variant.modal.form.status.false": "关闭",
  "Product.classify.variant.modal.form.status.true": "正常",
  "Product.detail.attribute.create.title": "创建属性",
  "Product.detail.attribute.edit.title": "更新属性",
  "Product.detail.attribute.empty":
    "暂无属性数据，如需添加属性，请在【商品分类-属性】中进行添加",
  "Product.detail.attribute.empty.info":
    "提示：商品已添加分类下暂无挂靠属性，如需添加商品属性，请先点击下方分类，选择属性后再编辑。",
  "Product.detail.attribute.empty.text":
    "商品暂无选择分类，请选择分类后，再添加属性",
  "Product.detail.attribute.no-more":
    "暂无属性数据，如需添加属性，请在【商品分类-属性】中进行添加或添加新的分类",
  "Product.detail.attribute.tip.row1":
    "1.商品属性挂靠在商品分类中，如没有找到需要的属性，可在对应分类下选择或者创建属性，选中分类后即可添加商品属性。",
  "Product.detail.attribute.tip.row2":
    "2.准确选择属性，有利于客户快速搜索和筛选出该商品。",
  "Product.detail.attribute.title": "商品属性（选填）",
  "Product.detail.attribute.title.info":
    "提示：属性与分类存在关联关系，当需要添加商品的特有属性，参数时，需要先选择对应分类，再选择分类下的属性。",
  "Product.detail.attribute.title.read": "商品属性",
  "Product.detail.basic.create.title": "创建商品",
  "Product.detail.basic.edit.title": "更新商品",
  "Product.detail.basic.form.category-id.tip.row1":
    "1.一个商品可添加多个商品分类。",
  "Product.detail.basic.form.category-id.tip.row2":
    "2.商品分类下关联规格与属性，关联分类后，可快捷使用关联的规格和属性创建商品。",
  "Product.detail.basic.form.category-ids": "商品分类",
  "Product.detail.basic.form.category-ids.empty": "商品分类不能为空",
  "Product.detail.basic.form.category-ids.placeholder": "请选择分类",
  "Product.detail.basic.form.code.tip":
    "商品编码是为了方便商家管理商品，可以在这里输入erp编码，库存编号，标准条码等；",
  "Product.detail.basic.form.commodity-code": "商品编码",
  "Product.detail.basic.form.detail-images": "商品详情-仅图片",
  "Product.detail.basic.form.detail-images.tip.row1":
    "1. 该字段仅支持多图片，建议使用富文本编辑商品详情。",
  "Product.detail.basic.form.detail-images.tip.row2":
    "2. 该字段最多支持10张图片上传，单张图片大学不能超过5M。",
  "Product.detail.basic.form.detail-images.tip.row3":
    "3. 仅支持以下图片格式：bmp、jpg、jpeg、png、gif、svg、tiff。",
  "Product.detail.basic.form.detail-rich-text": "商品详情-富文本",
  "Product.detail.basic.form.detail-rich-text.tip.row1":
    "1. 富文本编辑器最大可输入30000个字符（含部分HTML标记）。",
  "Product.detail.basic.form.detail-rich-text.tip.row2":
    "2. 支持插入 bmp、jpg、jpeg、png、gif、svg、tiff 图片格式。",
  "Product.detail.basic.form.detail-rich-text.tip.row3":
    "3. 单张图片文件大小不超过5M,最多支持20张图片上传。",
  "Product.detail.basic.form.detail-rich-text.tip.row4":
    "4. 使用超链接/图片链接，需要确认链接域名在白名单内，且需使用协议https。",
  "Product.detail.basic.form.detail-rich-text.tip.row5":
    "5. 如需查询Source状态下允许使用的HTML标记请查看用户指南的商品详情富文本相关内容。",
  "Product.detail.basic.form.image.tip.row1": "1.商品图片最多支持10张图片上传",
  "Product.detail.basic.form.image.tip.row2": "2.单张图片大小不能超过5M",
  "Product.detail.basic.form.image.tip.row3":
    "3.仅支持以下图片格式：bmp、jpg、jpeg、png、gif、svg、tiff",
  "Product.detail.basic.form.image.tip.row4":
    "4.添加图片链接仅支持添加白名单域名下的图片链接",
  "Product.detail.basic.form.images": "商品图片",
  "Product.detail.basic.form.images.valid.empty": "至少存在一张商品主图",
  "Product.detail.basic.form.materials": "商品图片和视频",
  "Product.detail.basic.form.purchase-limit": "每人限购",
  "Product.detail.basic.form.shelves-status": "商品上下架状态",
  "Product.detail.basic.form.sub-title": "商品描述",
  "Product.detail.basic.form.title": "商品名称",
  "Product.detail.basic.form.title.tooltip":
    "商品名称，SPU编码与SKU编码可搜索， SPU编码与SKU编码搜索需输入完整信息",
  "Product.detail.basic.form.video": "主图视频",
  "Product.detail.basic.form.video.attention.info.enum": {
    AVAILABLE: [
      "1.主图视频已转码成功，您可在商品详情中查看",
      "2.如需替换素材，请删除视频素材后，重新上传",
    ],
    ERROR: [
      "1.视频时长不能超过60S",
      "2.视频尺寸仅支持1：1或3：4",
      "3.视频码率不大于2048 (kbps) / 视频帧率不大于60 (fps)",
    ],
    NONE: [
      "1.视频大小不超过200M，不超过60s，仅支持MP4",
      "2.视频尺寸仅支持1：1或3：4",
      "3.视频码率不大于2048 (kbps) / 视频帧率不大于60 (fps)",
      "4.视频文件大于200M时，仅支持外部视频链接上传",
      "5.本地视频文件上传与外部视频链接只能二选一，如需切换视频上传方式，需把已有视频素材删除后再上传",
    ],
    TRANSCODING: [
      "1.转码中的视频不影响商品进行上架操作",
      "2.转码中的视频不会在外部应用展示，当转码成功后，才会展示",
      "3.转码中的视频不允许编辑，如需替换视频，请等待视频转码完成后操作",
    ],
  },
  "Product.detail.basic.form.video.attention.title.enum": {
    AVAILABLE: "注意：",
    ERROR: "主图视频转码失败，请检查以下内容后再重新上传视频：",
    NONE: "注意：",
    TRANSCODING:
      "为了安全考虑，视频需要进行转码处理，您可继续保存商品，系统将自动完成转码操作",
  },
  "Product.detail.basic.form.video.cover": "视频封面",
  "Product.detail.basic.form.video.cover.tooltip.row1":
    "1.视频封面最多支持1张图片上传",
  "Product.detail.basic.form.video.cover.tooltip.row2":
    "2.单张图片大小最多不超5M",
  "Product.detail.basic.form.video.cover.tooltip.row3":
    "3.支持图片格式：bmp、jpg、jpeg、png、gif、svg、tiff",
  "Product.detail.basic.form.video.link.action": "校验",
  "Product.detail.basic.form.video.link.title": "外部视频链接",
  "Product.detail.basic.form.video.link.tooltip":
    "注意：视频链接仅支持添加白名单域名视频链接，请联系管理员配置视频链接白名单",
  "Product.detail.basic.form.video.link.validate":
    "视频链接无法识别，请联系管理员配置视频链接白名单",
  "Product.detail.basic.form.video.tooltip.row1": "1.主图视频格式支持：MP4",
  "Product.detail.basic.form.video.tooltip.row2":
    "2.主图视频大小不超过200M，时长不超过60S",
  "Product.detail.basic.form.video.tooltip.row3":
    "3.主图视频最多支持1个视频上传",
  "Product.detail.basic.form.video.tooltip.row4": "4.视频尺寸仅支持1：1或3：4",
  "Product.detail.basic.form.video.tooltip.row5": "5.视频码率不大于2048 (kbps)",
  "Product.detail.basic.form.video.tooltip.row6": "6.视频帧率不大于60 (fps)",
  "Product.detail.basic.form.video.tooltip.row7":
    "7.主图视频上传完成后，系统将会自动进行转码，在此过程中不影响商品保存",
  "Product.detail.basic.form.video.upload-failed": "视频上传失败",
  "Product.detail.basic.form.video.upload-success": "视频已上传，转码中",
  "Product.detail.basic.title": "基本信息",
  "Product.detail.category.status.tip.row1":
    "1.上架：商品开启售卖，店铺中可以查看该商品数据，可购买，加购该商品。",
  "Product.detail.category.status.tip.row2":
    "2.下架：商品处于不可售卖状态，店铺中无法查看该商品数据，商品下架状态可进行商品信息的更新。",
  "Product.detail.detail.info.empty": "图文详情不能为空",
  "Product.detail.edit.save.enable": "保存并上架",
  "Product.detail.edit.save.enable.success":
    "操作成功，商品更新完成，商品已上架。",
  "Product.detail.edit.save.sku": "保存并创建SKU",
  "Product.detail.edit.save.success": "操作成功",
  "Product.detail.edit.title": "商品编辑",
  "Product.detail.entry.shelve.useless":
    "该商品处于上架状态无法编辑，请先下架该商品。",
  "Product.detail.external.attribute.action.title": "添加属性",
  "Product.detail.external.form.attributes": "商品属性",
  "Product.detail.external.form.attributes-holder": "请选择商品属性",
  "Product.detail.external.form.attributes-value-holder": "请选择商品属性值",
  "Product.detail.external.form.product-variant": "规格信息",
  "Product.detail.external.form.product-variant-multiple": "多规格",
  "Product.detail.external.form.product-variant-single": "统一规格",
  "Product.detail.external.sku-list.title": "SKU列表",
  "Product.detail.external.sku-list.valid.empty": "SKU列表不能为空",
  "Product.detail.external.title": "扩展信息",
  "Product.detail.external.variant.action.title": "添加规格",
  "Product.detail.external.variant.modal.form.variant-holder": "请选择规格",
  "Product.detail.external.variant.modal.form.variant-value-holder":
    "请选择规格值",
  "Product.detail.external.variant.puzzle.batch-set.cost": "成本价",
  "Product.detail.external.variant.puzzle.batch-set.fill": "设置",
  "Product.detail.external.variant.puzzle.batch-set.inventory": "库存",
  "Product.detail.external.variant.puzzle.batch-set.market": "市场价",
  "Product.detail.external.variant.puzzle.batch-set.sell": "销售价",
  "Product.detail.external.variant.puzzle.batch-set.title": "批量设置",
  "Product.detail.external.variant.puzzle.batch-set.volume": "体积（m³）",
  "Product.detail.external.variant.puzzle.batch-set.weight": "重量（kg）",
  "Product.detail.external.variant.puzzle.table.cell.operation.clear": "清空",
  "Product.detail.external.variant.puzzle.table.cell.operation.disable": "停用",
  "Product.detail.external.variant.puzzle.table.cell.operation.enable": "启用",
  "Product.detail.external.variant.puzzle.table.expand.column.sku-code":
    "SKU编码",
  "Product.detail.external.variant.puzzle.table.expand.column.sku-image":
    "SKU图片",
  "Product.detail.external.variant.puzzle.table.price.valid.max10":
    "价格长度字符不能超过10位",
  "Product.detail.external.variant.puzzle.table.sku-code.valid.error":
    "商品编码的输入只能是大小写英文，数字，横杠组成",
  "Product.detail.external.variant.puzzle.table.summary.sku-length":
    "SKU记录数：{num}",
  "Product.detail.external.variant.puzzle.table.valid.no-number": "该值不合法",
  "Product.detail.external.variant.title": "规格信息",
  "Product.detail.info.title": "图文详情",
  "Product.detail.read.category.modal.title": "修改分类",
  "Product.detail.read.sku.disabled.info":
    "商品暂无SKU信息，无法进行上架操作，请前往【价格与库存】中创建SKU信息",
  "Product.detail.read.sku.empty.info":
    "暂无SKU数据，请点击下方【编辑】按钮创建SKU",
  "Product.detail.read.status.action.disabled":
    "该商品将进行下架操作，下架后商品将不会在店铺中显示，客户无法购买该商品，是否下架？",
  "Product.detail.read.status.action.disabled.title": "下架商品",
  "Product.detail.read.status.action.enabled":
    "该商品将进行上架操作，上架后商品将会在店铺中显示，客户将可购买该商品，是否上架？",
  "Product.detail.read.status.action.enabled.title": "上架商品",
  "Product.detail.read.status.action.enabled.transcoding":
    "该商品将进行上架操作，商品视频还在转码中，无法在店铺中展示，您依然可以进行商品上架操作，上架后商品将会在渠道中显示，客户将可购买该商品，是否上架？",
  "Product.detail.read.status.action.prevent.row1":
    "商品无法进行上架操作，请检查：",
  "Product.detail.read.status.action.prevent.row2":
    "1. 商品SKU是否已创建完成；",
  "Product.detail.read.status.action.prevent.row3":
    "2. 至少有一条正常状态的商品SKU；",
  "Product.detail.read.status.action.prevent.title": "商品上架失败",
  "Product.detail.sku.batch-settings.dispatch.btn": "批量操作",
  "Product.detail.sku.batchSetting.tip.row1":
    "1.通过在输入框中输入对应数值，点击批量设置即可完成SKU信息的快速填充。",
  "Product.detail.sku.batchSetting.tip.row2":
    "2.禁用的SKU无法使用批量设置进行信息填写。",
  "Product.detail.sku.category": "商品已添加分类：",
  "Product.detail.sku.category.empty":
    "商品暂无选择分类，请选择分类后，再添加规格。",
  "Product.detail.sku.category.empty.btn": "添加分类",
  "Product.detail.sku.cost_price.validate.max": "输入无效，已超过输入最大值",
  "Product.detail.sku.create.title": "创建SKU",
  "Product.detail.sku.edit.title": "更新SKU",
  "Product.detail.sku.inventory.validate.max": "输入无效，已超过输入最大值",
  "Product.detail.sku.market_price.validate.max": "输入无效，已超过输入最大值",
  "Product.detail.sku.multiple.validate.require": "此项不能为0或负数",
  "Product.detail.sku.sell_price.validate.max": "输入无效，已超过输入最大值",
  "Product.detail.sku.single.info": "提示：填写下表格，可直接创建单规格",
  "Product.detail.sku.sku_code.validate.max": "输入无效，已超过输入最大位数",
  "Product.detail.sku.table.title": "价格与库存",
  "Product.detail.sku.value.validate.digit": "最多允许输入小数点后两位",
  "Product.detail.sku.variation": "商品规格（选填）",
  "Product.detail.sku.variation.empty":
    "暂无规格数据，如需添加规格，请在【商品分类-规格】中进行添加。",
  "Product.detail.sku.variation.empty.info":
    "商品已添加的分类下暂无挂靠规格，如需创建多规格商品，请先点击下方分类，选择规格后再编辑。",
  "Product.detail.sku.variation.info":
    "提示：如需创建多规格商品，需添加规格，创建多个SKU；如不添加，则默认单规格",
  "Product.detail.sku.variation.max-length": "规格添加已达上限",
  "Product.detail.sku.variation.no-more":
    "商品已添加分类下暂无挂靠规格，如需添加规格，请在【商品分类-规格】中进行添加。",
  "Product.detail.sku.variation.read": "商品规格",
  "Product.detail.sku.variation.tip.row1":
    "1.多规格商品需要添加对应的规格，添加成功后，价格与库存中自动加载对应的SKU列表。",
  "Product.detail.sku.variation.tip.row2": "2.规格最多只能添加10个。",
  "Product.detail.sku.variation.tip.row3": "3.SKU数量最多只能生成200个。",
  "Product.detail.sku.volume.validate.max": "输入无效，已超过输入最大值",
  "Product.detail.sku.weight.validate.max": "输入无效，已超过输入最大值",
  "Product.detail.spu.create.success": "创建成功",
  "Product.detail.spu.status.last-update": "最后更新时间",
  "Product.detail.spu.type.multiple": "多规格",
  "Product.detail.spu.type.none": "无规格",
  "Product.detail.spu.type.single": "单规格",
  "Product.detail.spu.type.tip.row1": "1.单规格：商品只有一条SKU，无规格信息。",
  "Product.detail.spu.type.tip.row2":
    "2.多规格：商品有一条或以上的SKU，有规格信息。",
  "Product.detail.spu.types": "商品种类",
  "Product.detail.spu.searchable-config": "搜索配置",
  "Product.detail.spu.searchable-config.yes": "可被搜索",
  "Product.detail.spu.searchable-config.no": "不可被搜索",
  "Product.detail.spu.searchable-config.tips.row1":
    "1.商品被设置为不可被搜索后，该商品将无法被搜索接口检索",
  "Product.detail.spu.searchable-config.tips.row2":
    "2.不可被搜索的商品将无法出现在分类下的商品列表，也不参与商品排序",
  "Product.detail.spu.searchable-config.tips.row3":
    "3.若通过店铺的接口打开该商品的详情页，不可被搜索的商品可正常加入购物车，进行下单",
  "Product.detail.spu.current-status": "当前上架状态",
  "Product.detail.spu.auto-online": "自动上架：",
  "Product.detail.spu.auto-offline": "自动下架：",
  "Product.detail.spu.auto-online-time": "自动上架时间",
  "Product.detail.spu.auto-offline-time": "自动下架时间",
  "Product.detail.spu.update.failed": "更新失败",
  "Product.detail.spu.update.success": "更新成功",
  "Product.detail.title": "商品编辑/创建",
  "Product.management.header.add": "创建商品",
  "Product.management.header.date.down": "商品下架日期",
  "Product.management.header.date.up": "商品上架日期",
  "Product.management.header.reset": "重置",
  "Product.management.header.search": "查询",
  "Product.management.header.shelves.down": "下架",
  "Product.management.header.shelves.status": "商品状态",
  "Product.management.header.shelves.up": "上架",
  "Product.management.header.spu.disable": "下架",
  "Product.management.header.spu.enable": "上架",
  "Product.management.header.spu.edit-status": "编辑上下架",
  "Product.management.header.title": "商品列表",
  "Product.management.list.delete.confirm": "请确认删除商品",
  "Product.management.list.delete.title": "删除商品",
  "Product.management.list.operation.edit.sku": "编辑SKU",
  "Product.management.list.operation.edit.spu": "编辑商品",
  "Product.management.list.search.name.placeholder": "请输入关键字",
  "Product.management.list.shelve.down.success": "下架成功",
  "Product.management.list.shelve.up.success": "上架成功",
  "Product.management.list.un-shelve.confirm": "请确认下架商品",
  "Product.management.table.column.product-action-delete": "删除",
  "Product.management.table.column.product-action-edit": "编辑",
  "Product.management.table.column.product-action-preview": "查看详情",
  "Product.management.table.column.product-empty": "暂无数据",
  "Product.management.table.column.product-id": "商品ID",
  "Product.management.table.column.product-image": "商品主图",
  "Product.management.table.column.product-inventory": "库存",
  "Product.management.table.column.product-sales": "销售价",
  "Product.management.table.column.product-shelves-time": "上下架时间",
  "Product.management.table.column.product-status": "商品状态",
  "Product.management.table.column.situation": "商品情况",
  "Product.management.title": "商品管理",
  "Product.preview.header.back-list": "返回商品列表",
  "Product.preview.table.filter.search.tooltip":
    "商品ID，商品信息，评价内容可搜索。ID搜索需输入完整信息。",
  "Product.preview.title": "商品详情",
  "Product.property.modal.related.none.error": "请至少选择一项进行关联",
  "Product.property.modal.search.placeholder": "请输入关键词",
  "Product.property.table.column.operation.cancel-related": "取消选择",
  "Product.property.table.column.operation.show-in-channel.close": "关闭筛选",
  "Product.property.table.column.operation.show-in-channel.close.success":
    "已关闭",
  "Product.property.table.column.operation.show-in-channel.open": "开启筛选",
  "Product.property.table.column.operation.show-in-channel.open.success":
    "已开启",
  "Product.property.table.column.operation.show-in-channel.open.tip.row1":
    "1.在店铺中，客户可以根据分类，规格，属性进行商品的筛选。当分类下属性的可筛选状态为：",
  "Product.property.table.column.operation.show-in-channel.open.tip.row2":
    "可筛选：客户可以在店铺中使用属性进行商品的筛选",
  "Product.property.table.column.operation.show-in-channel.open.tip.row3":
    "不可筛选：客户不可以在店铺中使用属性进行商品的筛选，但不影响SKU的选择和下单",
  "Product.property.table.column.operation.show-in-channel.open.tip.row4":
    "2.您可通过【开启筛选/关闭筛选】按钮来切换。",
  "Product.property.table.column.show-in-channel": "店铺中可筛选",
  "Product.property.table.column.show-in-channel.shown": "可筛选",
  "Product.property.table.column.show-in-channel.un-show": "不可筛选",
  "Product.purchase-limit.edit.info":
    "限购规则的修改只能影响新订单，无法修改客户已经创建的订单",
  "Product.purchase-limit.edit.title": "编辑限购规则",
  "Product.purchase-limit.rule": "限购规则",
  "Product.purchase-limit.status": "限购状态",
  "Product.purchase-limit.status.disabled": "禁用",
  "Product.purchase-limit.status.enabled": "启用",
  "Product.purchase-limit.variation": "限购类型",
  "Product.purchase-limit.variation.sku": "SKU限购",
  "Product.purchase-limit.variation.sku.column.title": "限购数量",
  "Product.purchase-limit.variation.sku.disabled": "不限购",
  "Product.purchase-limit.variation.sku.enabled": "限购",
  "Product.purchase-limit.variation.spu": "SPU限购",
  "Product.purchase-limit.variation.union": "件 / 人",
  "Product.review.detail.header-actions.approve": "审核通过",
  "Product.review.detail.header-actions.hide-display": "隐藏评价",
  "Product.review.detail.header-actions.reject": "审核不通过",
  "Product.review.detail.header-actions.show-display": "显示评价",
  "Product.review.detail.header-details.channel-name": "渠道名称",
  "Product.review.detail.header-details.created-at": "评价时间",
  "Product.review.detail.header-details.customer-id": "客户ID",
  "Product.review.detail.header-details.customer-name": "客户名称",
  "Product.review.detail.header-details.order-no": "订单ID",
  "Product.review.detail.header-details.spu-id": "商品ID",
  "Product.review.detail.header-details.storefront-name": "店铺名称",
  "Product.review.detail.review-content.basic": "基本信息",
  "Product.review.detail.review-content.basic.content": "评价内容",
  "Product.review.detail.review-content.basic.review-display": "显示状态",
  "Product.review.detail.review-content.basic.score": "评分",
  "Product.review.detail.review-content.images": "评价图片",
  "Product.review.detail.reviewer.content": "审核人：{name}",
  "Product.review.detail.reviewer.heading": "审核人",
  "Product.review.detail.sku-info.basic": "基本信息",
  "Product.review.detail.sku-info.basic.quantity": "购买数量",
  "Product.review.detail.sku-info.basic.sell-price": "销售价",
  "Product.review.detail.sku-info.basic.spu-id": "商品ID",
  "Product.review.detail.sku-info.basic.spu-name": "商品名称",
  "Product.review.detail.sku-info.basic.variation-attribute": "规格",
  "Product.review.detail.sku-info.image": "SKU图片",
  "Product.review.detail.status.heading": "审核状态",
  "Product.review.detail.tab.content": "评价内容",
  "Product.review.detail.tab.spu-info": "商品信息",
  "Product.review.detail.title": "评价详情",
  "Product.review.hooks.constant.approve.approved": "审核通过",
  "Product.review.hooks.constant.approve.pending": "待审核",
  "Product.review.hooks.constant.approve.rejected": "审核不通过",
  "Product.review.hooks.constant.review-display.hide": "隐藏",
  "Product.review.hooks.constant.review-display.visible": "显示",
  "Product.review.list.card-actions.approve": "批量审核通过",
  "Product.review.list.card-actions.reject": "批量审核不通过",
  "Product.review.list.tab-label-all": "全部评价",
  "Product.review.list.tab-label-pending": "待审核评价",
  "Product.review.list.table-columns.approve-status.title": "审核状态",
  "Product.review.list.table-columns.channel-name.title": "渠道名称",
  "Product.review.list.table-columns.content.title": "评价内容",
  "Product.review.list.table-columns.created-at.title": "评价时间",
  "Product.review.list.table-columns.operation.approve": "审核通过",
  "Product.review.list.table-columns.operation.hide-display": "隐藏评价",
  "Product.review.list.table-columns.operation.reject": "审核不通过",
  "Product.review.list.table-columns.operation.show-display": "显示评价",
  "Product.review.list.table-columns.operation.visit-detail": "详情",
  "Product.review.list.table-columns.review-display.title": "显示状态",
  "Product.review.list.table-columns.score.title": "评分",
  "Product.review.list.table-columns.spu-id.title": "商品ID",
  "Product.review.list.table-columns.spu-info.sell-price": "销售价：{price}",
  "Product.review.list.table-columns.spu-info.title": "商品信息",
  "Product.review.list.table-columns.spu-info.variation-attribute":
    "规格：{variationAttribute}",
  "Product.review.list.table-columns.storefront-name.title": "店铺名称",
  "Product.review.list.table-control.approve-status.placeholder": "审核状态",
  "Product.review.list.table-control.channel.placeholder": "渠道名称",
  "Product.review.list.table-control.compact-input.field.options.spu-id":
    "商品ID",
  "Product.review.list.table-control.compact-input.field.options.spu-name":
    "商品名称",
  "Product.review.list.table-control.compact-input.field.placeholder":
    "字段查询",
  "Product.review.list.table-control.compact-input.search-value.placeholder":
    "请输入关键词",
  "Product.review.list.table-control.data-range.placeholder.end": "结束时间",
  "Product.review.list.table-control.data-range.placeholder.start": "开始时间",
  "Product.review.list.table-control.review-display.placeholder": "显示状态",
  "Product.review.list.table-control.storefront.placeholder": "店铺名称",
  "Product.review.list.title": "商品评价",
  "Product.review.prompt.approve.content": "是否确认审核通过该评价？",
  "Product.review.prompt.approve.title": "审核通过",
  "Product.review.prompt.batchApprove.content": "是否批量审核通过{num}条评价？",
  "Product.review.prompt.batchApprove.title": "批量审核通过",
  "Product.review.prompt.batchReject.content":
    "审核不通过后，评价将不能设置为显示，是否确认批量审核不通过{num}条评价？",
  "Product.review.prompt.batchReject.title": "批量审核不通过",
  "Product.review.prompt.hide-display.content":
    "隐藏评价信息后，评价将会在店铺商品详情中隐藏，是否继续隐藏评价？",
  "Product.review.prompt.hide-display.title": "隐藏评价",
  "Product.review.prompt.reject.content":
    "审核不通过后，评价不能设置为显示是否确认？",
  "Product.review.prompt.reject.title": "审核不通过",
  "Product.review.prompt.show-display.content":
    "显示评价信息后，评价将会在店铺商品详情中展示，是否继续显示评价？",
  "Product.review.prompt.show-display.title": "显示评价",
  "Product.situation.enum": {
    video: { AVAILABLE: "正常", ERROR: "转码失败", TRANSCODING: "视频转码中" },
  },
  "Product.sku.status": "状态",
  "Product.sku.status.disabled": "关闭",
  "Product.sku.status.enabled": "开启",
  "Product.title": "商品",
  "Product.variation.create.info.row1":
    "1.列表中的规格信息是当前规格库里的所有规格，每个规格都可以关联多个分类。",
  "Product.variation.create.info.row2":
    "2.删除规格将会使所有分类取消关联该规格，并从规格库中删除该规格，该操作无法恢复。",
  "Product.variation.info.row1":
    "1.您需要先在分类中关联规格，才能在创建商品时快捷使用该分类下的规格值创建多个SKU。",
  "Product.variation.info.row2":
    "2.规格可以被多个分类进行关联，若在分类下取消关联规格，不影响已创建的SKU。",
  "Product.variation.modal.delete.info":
    "该规格将会从规格库中删除，删除后不可恢复，且所有分类下都自动取消选择该规格，是否删除？",
  "Product.variation.status": "规格状态",
  "Product.variation.status.close": "关闭",
  "Product.variation.status.info":
    "规格状态影响该规格数据能否在创建商品时使用，已创建成功商品不受影响。",
  "Product.variation.status.open": "开启",
  "Product.variation.table.column.operation.cancel-related.info.row1":
    "取消选择该规格，将无法在创建商品过程中使用该规格",
  "Product.variation.table.column.operation.cancel-related.info.row2": "注意：",
  "Product.variation.table.column.operation.cancel-related.info.row3":
    "1.如需再次使用该规格，可重新选择规格。",
  "Product.variation.table.column.operation.cancel-related.info.row4":
    "2.取消选择该规格不会影响已创建的商品。",
  "Product.variation.value.add": "添加规格值",
  "Product.variation.value.name.placeholder": "请输入规格值",
  "Product.management.header.edit-sort": "编辑排序",
  "Product.related-spu.sort-modal.page-sort-info":
    "您正在编辑当前页面的商品排序。当前页面{pageSize}条/页 页码：第{pageNumber}页    当前排序的商品： {startIndex}-{endIndex} items",
  "Product.detail.basic.form.default-position": "分类下的排序",
  "Product.detail.basic.form.default-position.top": "置顶",
  "Product.detail.basic.form.default-position.bottom": "置底",
  "Product.presale.name": "预售",
  "Product.management.list.operation.un-presale": "取消预售",
  "Product.management.list.operation.presale": "设为预售商品",
  "Product.management.un-presale.info":
    "请确认是否设置该商品的预售状态为普通商品",
  "Product.management.presale.info": "请确认该商品的预售信息，并提交更改",
  "Product.management.un-presale.time-up.enable": "转为普通商品并上架该商品",
  "Product.management.un-presale.time-up.disable": "转为普通商品并下架该商品",
  "Product.management.presale.schedule.time": "预售时间",
  "Product.management.presale.schedule.time-up.action": "预售结束后",
  "Product.management.presale.status": "预售状态",
  "Product.management.presale.status.normal.spu": "普通商品",
  "Product.management.presale.status.presale.spu": "预售商品",
  "Product.management.inventory_min": "最小库存",
  "Product.management.inventory_max": "最大库存",
  "Product.presale.tips": [
    "未到预售时间，无法创建含有该商品的订单。",
    "预售期间，含有预售商品的订单为预售订单",
    "预售时间结束后，已创建的预售订单不受影响",
    "预售结束后若设置为转为普通商品，则后续创建的订单为普通订单",
  ],
  "Product.spu.tag-type.presale": "商品类型",
  "Product.spu.basic.edit.enable.tip":
    "当前商品正处于上架状态，您的编辑将影响该商品在店铺的展示。",
  "Promotion.detail.tab.discount.meta-info.tips":
    "如果设置多级优惠，仅按照满足条件的情形生效对应级别的优惠内容。",
  "Promotion.detail.tab.discount.selected-gift": "已选赠品",
  "Promotion.detail.tab.discount.table.granted_quantity": "赠品数",
  "Promotion.detail.tab.discount.table.granted_quantity.tips":
    "满足门槛金额后赠送该赠品的数量。",
  "Promotion.detail.tab.discount.table.inventory": "剩余库存",
  "Promotion.detail.tab.discount.table.name": "商品名称",
  "Promotion.detail.tab.discount.table.sku-id": "SKU ID",
  "Promotion.detail.tab.discount.table.sku-image": "SKU图片",
  "Promotion.details.header.type.value.amount-discount": "满减",
  "Promotion.details.header.type.value.gift": "满赠",
  "Promotion.details.header.type.value.percentage-discount": "满折",
  "Promotion.details.headers.id": "促销ID",
  "Promotion.details.headers.name": "促销名称",
  "Promotion.details.headers.product-range": "参与商品",
  "Promotion.details.headers.status": "促销状态",
  "Promotion.details.headers.type": "促销类型",
  "Promotion.details.tab.goods.notice.row1": "全场商品均参与该促销。",
  "Promotion.details.tab.goods.notice.row2":
    "全场商品参与的条件下，促销对所有上架商品生效。包含下架后上架的商品或者新创建的上架商品。",
  "Promotion.details.tab.info.details": "促销详情",
  "Promotion.details.tab.info.name": "促销名称",
  "Promotion.details.tab.info.product-range": "参与商品",
  "Promotion.details.tab.info.remark": "内部备注",
  "Promotion.details.tab.info.rule": "优惠规则",
  "Promotion.details.tab.info.rule.no-condition": "无门槛送赠品",
  "Promotion.details.tab.info.rule.tmpl": "满{threshold}{type}送赠品",
  "Promotion.details.tab.info.store": "适用店铺",
  "Promotion.details.tab.info.time-scope": "促销时间",
  "Promotion.details.tab.info.type": "优惠类型",
  "Promotion.details.tabs.title.info": "促销信息",
  "Promotion.details.tabs.title.order-record": "订单记录",
  "Promotion.details.tabs.title.product-range": "参与商品",
  "Promotion.details.tabs.title.rules": "优惠详情",
  "Promotion.details.title": "促销详情",
  "Promotion.list.colum.operation.close.modal.content":
    "确认结束该促销吗？结束后不可恢复且不影响已参加促销的客户。",
  "Promotion.list.colum.operation.close.modal.title": "结束促销",
  "Promotion.list.colum.operation.delete.modal.content":
    "确认删除该促销吗？删除后数据不可恢复，请谨慎操作。",
  "Promotion.list.colum.operation.delete.modal.title": "删除促销",
  "Promotion.list.colum.operation.pause.modal.content":
    "确认暂停该促销吗？暂停该促销后，店铺将无法获取数据。",
  "Promotion.list.colum.operation.pause.modal.title": "暂停促销",
  "Promotion.list.colum.operation.start.modal.content": "确认开始该促销吗？",
  "Promotion.list.colum.operation.start.modal.title": "开始促销",
  "Promotion.list.column.label.name": "促销名称",
  "Promotion.list.column.label.status": "促销状态",
  "Promotion.list.column.label.store": "适用店铺",
  "Promotion.list.column.label.time": "促销时间",
  "Promotion.list.column.label.type": "促销类型",
  "Promotion.list.column.operation.close": "结束",
  "Promotion.list.column.operation.pause": "暂停",
  "Promotion.list.column.operation.start": "开始",
  "Promotion.list.column.time.value.label.end": "结束：",
  "Promotion.list.column.time.value.label.start": "开始：",
  "Promotion.list.header.action.create": "创建促销",
  "Promotion.list.header.action.create.modal.content.type.amount-discount.desc":
    "订单满额减元",
  "Promotion.list.header.action.create.modal.content.type.amount-discount.title":
    "满减",
  "Promotion.list.header.action.create.modal.content.type.giving.desc":
    "满额赠礼/直赠",
  "Promotion.list.header.action.create.modal.content.type.giving.title": "满赠",
  "Promotion.list.header.action.create.modal.content.type.joint.desc": "拼团",
  "Promotion.list.header.action.create.modal.content.type.joint.title": "拼团",
  "Promotion.list.header.action.create.modal.content.type.percentage-discount.desc":
    "订单满额打折",
  "Promotion.list.header.action.create.modal.content.type.percentage-discount.title":
    "满折",
  "Promotion.list.header.action.create.modal.title": "选择促销类型",
  "Promotion.list.header.statistical.count": "{count}个项目",
  "Promotion.list.toolbar.date.placeholder.end": "结束时间",
  "Promotion.list.toolbar.date.placeholder.start": "开始时间",
  "Promotion.list.toolbar.input.name.placeholder": "请输入促销名称",
  "Promotion.list.toolbar.select.status.placeholder": "促销状态",
  "Promotion.list.toolbar.select.store.placeholder": "适用店铺",
  "Promotion.list.toolbar.select.type.placeholder": "促销类型",
  "Promotion.management.title": "促销",
  "Promotion.patch.create.title": "创建促销",
  "Promotion.patch.step.type.amount-discount.desc": "满减",
  "Promotion.patch.step.type.giving.desc": "满赠",
  "Promotion.patch.step.type.percentage-discount.desc": "满折",
  "Promotion.patch.step1.form.date.label": "促销时间",
  "Promotion.patch.step1.form.date.label.valid.end": "结束时间不能小于开始时间",
  "Promotion.patch.step1.form.date.label.valid.start":
    "开始时间不能小于当前时间",
  "Promotion.patch.step1.form.date.label.valid.current":
    "结束时间不能小于当前时间",
  "Promotion.patch.step1.form.date.placeholder.end": "结束时间",
  "Promotion.patch.step1.form.date.placeholder.start": "开始时间",
  "Promotion.patch.step1.form.date.tooltip": "秒级设定为00",
  "Promotion.patch.step1.form.detail.label": "促销详情",
  "Promotion.patch.step1.form.detail.placeholder":
    "请输入详情内容（500个字以内）",
  "Promotion.patch.step1.form.internal-remark": "内部备注",
  "Promotion.patch.step1.form.internal-remark.placeholder":
    "请输入备注内容（仅作内部使用，500个字以内）",
  "Promotion.patch.step1.form.name.label": "促销名称",
  "Promotion.patch.step1.form.name.placeholder":
    "请输入促销名称（1-50个字以内）",
  "Promotion.patch.step1.form.participation-limit": "促销限制参与次数",
  "Promotion.patch.step1.form.participation-limit.no-limit": "不限",
  "Promotion.patch.step1.form.participation-limit.tips":
    "默认不限制，最多设置10次",
  "Promotion.patch.step1.form.participation-limit.tips.new":
    "新客默认首笔成交订单参与促销",
  "Promotion.patch.step1.form.participation-limit.tooltip":
    "每个客户ID限制参与促销的次数。",
  "Promotion.patch.step1.form.store.label": "适用店铺",
  "Promotion.patch.step1.form.store.placeholder": "请选择（单选）",
  "Promotion.patch.step1.form.target-customers": "定向人群",
  "Promotion.patch.step1.form.target-customers.all": "全部客户",
  "Promotion.patch.step1.form.target-customers.new": "新客",
  "Promotion.patch.step1.form.target-customers.tooltip":
    "新客：无成交订单的客户，适合新人礼的促销场景。",
  "Promotion.patch.step1.title": "基本信息",
  "Promotion.patch.step2.form.all.product.modal.tip":
    "商品不可选的原因是该商品已参加互斥的促销。",
  "Promotion.patch.step2.form.discount.scope.tooltip.row1":
    "1. 一个店铺在同一个时间最多只能有1个全场商品参与的满减或满折促销。",
  "Promotion.patch.step2.form.discount.scope.tooltip.row2":
    "2. 一个商品在同一个店铺同一个时间只能参与1个部分商品参与的满减或满折促销。",
  "Promotion.patch.step2.form.discount.scope.tooltip.row3":
    "3. 若该商品同时存在于全部商品参与和部分商品参与的满减或满折促销时，只生效部分商品参与的满减或满折促销。",
  "Promotion.patch.step2.form.gift.product.action.add": "添加商品",
  "Promotion.patch.step2.form.gift.product.choose": "已选择{count}件",
  "Promotion.patch.step2.form.gift.product.label": "选择商品",
  "Promotion.patch.step2.form.gift.product.placeholder": "请输入商品名称",
  "Promotion.patch.step2.form.gift.product.category": "请选择商品分类",
  "Promotion.patch.step2.form.gift.product.table.colum.id": "商品ID",
  "Promotion.patch.step2.form.gift.product.table.colum.image": "商品图片",
  "Promotion.patch.step2.form.gift.product.table.colum.name": "商品名称",
  "Promotion.patch.step2.form.gift.product.table.colum.operation.move": "移除",
  "Promotion.patch.step2.form.gift.product.table.colum.sell_price": "销售价",
  "Promotion.patch.step2.form.gift.product.valid.empty": "请选择参与促销的商品",
  "Promotion.patch.step2.form.gift.scope.item.all": "全场商品参与",
  "Promotion.patch.step2.form.gift.scope.item.part": "部分商品参与",
  "Promotion.patch.step2.form.gift.scope.label": "参与商品范围",
  "Promotion.patch.step2.form.gift.scope.tooltip.row1":
    "1. 一个店铺在同一个时间最多可以有5个全场商品参与的满赠促销。",
  "Promotion.patch.step2.form.gift.scope.tooltip.row2":
    "2. 一个商品在同一个店铺同一个时间只能参与一个部分商品参与的满赠促销。",
  "Promotion.patch.step2.submit.valid.modal.info.row1":
    "检测到有{inValidSpus}件已选商品不可用，可能是商品被删除或者参加其他互斥促销导致。",
  "Promotion.patch.step2.submit.valid.modal.info.row2":
    "* 点击确认将自动移除以下商品并提交信息，点击取消请到已选商品列表中手动移除。",
  "Promotion.patch.step2.submit.valid.modal.info.row3":
    "* 当已选商品全部不可用时，将自动跳转到已选商品列表中重新操作。",
  "Promotion.patch.step2.submit.valid.modal.title": "移除商品",
  "Promotion.patch.step2.title": "参与范围",
  "Promotion.patch.step3.gift-already-chosen-notification":
    "部分赠品在活动时间内参与多个活动，且参与商品有重叠，请注意活动配置是否符合预期，避免重复赠送相同的赠品。",
  "Promotion.patch.step3.gift-already-chosen-notification.pormotion-name":
    "活动名称",
  "Promotion.patch.step3.form.rule-type": "优惠类型",
  "Promotion.patch.step3.form.rule-type.less.value": "无门槛",
  "Promotion.patch.step3.form.rule-type.pieces.value": "满件",
  "Promotion.patch.step3.form.rule-type.yuan.value": "满元",
  "Promotion.patch.step3.form.rules.content.amount-discount.input":
    "减{discountAmount}元",
  "Promotion.patch.step3.form.rules.content.amount-discount.valid":
    "仅支持1-100000数字，限制最多两位小数",
  "Promotion.patch.step3.form.rules.content.amount-discount.valid.than":
    "减元数额必须小于满元数额",
  "Promotion.patch.step3.form.rules.content.discount.valid.than":
    "阶梯优惠力度必须递增",
  "Promotion.patch.step3.form.rules.content.gift.modal.notification.row1":
    "1. 只能选择上架的单规格赠品，参加促销（包含未开始，进行中，已暂停状态）的赠品不允许下架。",
  "Promotion.patch.step3.form.rules.content.gift.modal.notification.row2":
    "2. 一个赠品在同一个店铺同一时间只能参加一个满赠促销。赠品不能选择的原因是该赠品已参加互斥促销。",
  "Promotion.patch.step3.form.rules.content.gift.modal.search.placeholder":
    "请输入赠品名称",
  "Promotion.patch.step3.form.rules.content.gift.select-sku.action": "添加赠品",
  "Promotion.patch.step3.form.rules.content.gift.select-sku.count":
    "最多可选择15件，已选择{skuCount}件",
  "Promotion.patch.step3.form.rules.content.gift.select-sku.label": "选择赠品",
  "Promotion.patch.step3.form.rules.content.gift.select-sku.tooltip":
    "满足门槛金额后赠送该赠品的数量。",
  "Promotion.patch.step3.form.rules.content.gift.select-sku.valid.max":
    "最多选择15件赠品",
  "Promotion.patch.step3.form.rules.content.gift.table.column.count": "赠品数",
  "Promotion.patch.step3.form.rules.content.gift.table.column.count.required":
    "此项不能0或空",
  "Promotion.patch.step3.form.rules.content.gift.table.column.count.valid.limit":
    "仅支持1-10整数",
  "Promotion.patch.step3.form.rules.content.gift.table.column.count.valid.max":
    "不能超过剩余库存",
  "Promotion.patch.step3.form.rules.content.gift.table.column.image": "SKU图片",
  "Promotion.patch.step3.form.rules.content.gift.table.column.inventory":
    "剩余库存",
  "Promotion.patch.step3.form.rules.content.gift.table.column.name": "商品名称",
  "Promotion.patch.step3.form.rules.content.gift.table.column.operation.remove":
    "移除",
  "Promotion.patch.step3.form.rules.content.gift.value": "送赠品",
  "Promotion.patch.step3.form.rules.content.label": "优惠内容",
  "Promotion.patch.step3.form.rules.content.percentage-discount.input":
    "优惠{discountPercentage}%",
  "Promotion.patch.step3.form.rules.content.percentage-discount.valid":
    "仅支持1-90正整数",
  "Promotion.patch.step3.form.rules.selectable-gift-amount": "客户自选赠品件数",
  "Promotion.patch.step3.form.rules.selectable-gift-amount.tips":
    "不勾选择默认全部送出，勾选最多设置5件，自选赠品件数不得超过已选赠品件数",
  "Promotion.patch.step3.form.rules.selectable-gift-amount.valid.limit":
    "自选赠品件数不得超过已选赠品件数",
  "Promotion.patch.step3.form.rules.threshold.gift.input": "满{price}元",
  "Promotion.patch.step3.form.rules.threshold.gift.valid":
    "仅支持1-100000数字，限制最多两位小数",
  "Promotion.patch.step3.form.rules.threshold.label": "优惠门槛",
  "Promotion.patch.step3.form.rules.threshold.pieces.input": "满{count}件",
  "Promotion.patch.step3.form.rules.threshold.pieces.valid":
    "仅支持1-100000数字",
  "Promotion.patch.step3.form.rules.threshold.valid.than":
    "阶梯门槛数额必须递增",
  "Promotion.patch.step3.save-as-draft": "保存草稿",
  "Promotion.patch.step3.section": "优惠规则",
  "Promotion.patch.step3.section.1": "一级优惠",
  "Promotion.patch.step3.section.2": "二级优惠",
  "Promotion.patch.step3.section.3": "三级优惠",
  "Promotion.patch.step3.section.add.action.tip":
    "+ 添加优惠（最多可添加至三级）",
  "Promotion.patch.step3.submit.valid.modal.info.row1":
    "检测到有{inValidSkus}件已选赠品不可用，可能是赠品被删除或者被下架或者参加其他互斥促销导致。",
  "Promotion.patch.step3.submit.valid.modal.info.row2":
    "点击确认将自动移除以下赠品并提交信息，点击取消请到已选赠品列表中手动移除。",
  "Promotion.patch.step3.submit.valid.modal.title": "移除赠品",
  "Promotion.patch.step3.title": "优惠设置",
  "Promotion.patch.step3.tooltip":
    "如果设置多级优惠，仅按照满足条件的情形生效对应级别的优惠内容。",
  "Promotion.patch.step3.gift-already-chosen-modal.title": "提示",
  "Promotion.patch.step3.gift-already-chosen-modal.msg":
    "部分赠品在活动时间内参与多个促销活动，存在多次赠送的可能，是否保存活动配置？",
  "Promotion.patch.step3.gift-already-chosen-modal.radio-label":
    "是的，我已检查配置，确认无误",
  "Promotion.patch.update.title": "编辑促销",
  "Promotion.status.enum.CLOSED": "已结束",
  "Promotion.status.enum.DRAFT": "草稿",
  "Promotion.status.enum.IN_PROGRESS": "进行中",
  "Promotion.status.enum.NOT_STARTED": "未开始",
  "Promotion.status.enum.PAUSED": "已暂停",
  "Promotion.title": "促销",
  "Promotion.toast.success.promotion.operation.close": "已结束",
  "Promotion.toast.success.promotion.operation.delete": "已删除",
  "Promotion.toast.success.promotion.operation.pause": "已暂停",
  "Promotion.toast.success.promotion.operation.start": "已开启",
  "Promotion.toast.warning.promotion.in_progress":
    "促销正在进行中无法编辑，请先暂停促销。",
  "Webhook.Webhook.table.send-status.title": "发送情况",
  "Webhook.Webhook.table.send-status.title.abnormal": "异常",
  "Webhook.Webhook.table.send-status.title.normal": "正常",
  "Webhook.WebhookEdit.title": "编辑Webhook",
  "Webhook.WebhookList.action.add": "创建Webhook",
  "Webhook.WebhookList.checkWebhook.error": "远程服务器返回的HTTP状态代码为400",
  "Webhook.WebhookList.checkWebhook.success":
    "远程服务器返回的HTTP状态代码为200",
  "Webhook.WebhookList.deleteWebhook.error": "删除Webhook前需要先停用该事件",
  "Webhook.WebhookList.retryWebhook.success": "已触发手动重试请求！",
  "Webhook.WebhookList.table.activated.isFalse": "停用",
  "Webhook.WebhookList.table.activated.isTrue": "启用",
  "Webhook.WebhookList.table.activated.title": "状态",
  "Webhook.WebhookList.table.lastTriggerAt.title": "最新成功推送时间",
  "Webhook.WebhookList.table.lastTriggerResult.title": "最新触发结果",
  "Webhook.WebhookList.table.operation.changeActivatedTips":
    "确定{activated}该Webhook？",
  "Webhook.WebhookList.table.operation.check": "测试",
  "Webhook.WebhookList.table.operation.deleteTips":
    "确定删除该Webhook？删除后事件将无法找回，原有事件将无法推送至第三方平台!",
  "Webhook.WebhookList.table.operation.editTips":
    "编辑Webhook前需要先停用该事件？确定停用?",
  "Webhook.WebhookList.table.operation.failedResend": "失败重发",
  "Webhook.WebhookList.table.operation.failedResend.failed": "重发失败",
  "Webhook.WebhookList.table.operation.failedResend.success": "重发成功",
  "Webhook.WebhookList.table.operation.retry": "手动重试",
  "Webhook.WebhookList.table.operation.retry.Prompt.title": "Webhook事件更新",
  "Webhook.WebhookList.table.operation.retry.Prompt.validateError":
    "请输入开始时间/结束时间",
  "Webhook.WebhookList.title": "Webhooks",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row1.desc":
    "Webhook可根据事件类型和推送渠道进行命名，以提高可读性。",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row1.title": "Webhook名称：",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row2.desc":
    "Webhook的事件类型是指是触发通知的事件种类。目前系统支持的事件类型有以下几种：订单支付成功、订单超时取消、客户订单已发货。每一种事件类型会推送指定的参数到目标URL。",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row2.title": "事件类型：",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row3.desc":
    "Webhook被触发后，发送HTTPS通知的目标地址。",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row3.title": "URL：",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row4.desc":
    "Webhook密码/密钥，用于Webhook鉴权的方式，可通过Webhook密码/密钥生成请求签名进行鉴权，防止URL被恶意请求。",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row4.title": "密钥：",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row5.desc":
    "完成信息填写后，对需要推送的的URL进行健康检查，将JSON数据发布到指定URL中，请求代码案例如下：",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row5.title": "测试：",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row6.desc":
    "启用即激活Webhook。",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row6.title": "启用/禁用：",
  "Webhook.WebhookPost.RoutePrompt.message":
    "取消将不保存已编辑的数据！确定则退出回到列表页",
  "Webhook.WebhookPost.ScopedNotification.row1": "注意：",
  "Webhook.WebhookPost.ScopedNotification.row2":
    "1.请根据提示完成所有必填项填写，同时，URL目标地址需注意将返回的 Response Status Code 配置为 200，Response Body 配置为 success后，该URL才能正常识别，该Webhook才能正常保存；",
  "Webhook.WebhookPost.ScopedNotification.row3":
    "2.若提示保存失败，则说明URL不能识别，请检查URL是否正确，或者上述配置不正确；",
  "Webhook.WebhookPost.ScopedNotification.row4":
    "3.如遇配置问题，可点击帮助文档获取更多信息：",
  "Webhook.WebhookPost.create.success": "已创建！",
  "Webhook.WebhookPost.pageHeaderAction.content.row_1":
    "Webhook名称：Webhook可根据事件类型和推送渠道进行命名，以提高可读性。",
  "Webhook.WebhookPost.pageHeaderAction.content.row_2":
    "事件类型： Webhook的事件类型是指是触发通知的事件种类。目前系统支持的事件类型有以下几种：订单支付成功、订单超时取消、客户订单已发货。每一种事件类型会推送指定的参数到目标URL。",
  "Webhook.WebhookPost.pageHeaderAction.content.row_3":
    "URL: Webhook被触发后，发送HTTPS通知的目标地址。",
  "Webhook.WebhookPost.pageHeaderAction.content.row_4":
    "密钥: Webhook密码/密钥，用于Webhook鉴权的方式，可通过Webhook密码/密钥生成请求签名进行鉴权，防止URL被恶意请求。",
  "Webhook.WebhookPost.pageHeaderAction.content.row_5":
    "测试: 完成信息填写后，对需要推送的的URL进行健康检查，将JSON数据发布到指定URL中，请求代码案例如下：",
  "Webhook.WebhookPost.pageHeaderAction.content.row_6":
    "启用/禁用: 启用即激活Webhook。",
  "Webhook.WebhookPost.pageHeaderAction.title": "Webhook操作说明",
  "Webhook.WebhookPost.test.link": "查看帮助文档",
  "Webhook.WebhookPost.test.result.failed":
    "保存失败：当前状态为{code}，远端服务器返回不符合预期。",
  "Webhook.WebhookPost.test.result.failed.detail": "查看返回结果",
  "Webhook.WebhookPost.test.result.failed.info.correct": "正确返回示例：",
  "Webhook.WebhookPost.test.result.failed.info.in-correct": "错误返回结果：",
  "Webhook.WebhookPost.test.result.failed.title": "返回结果",
  "Webhook.WebhookPost.test.result.success":
    "成功：远程服务器返回的HTTP状态代码为200",
  "Webhook.WebhookPost.title": "创建Webhook",
  "Webhook.WebhookPost.update.success": "已编辑！",
  "Webhook.common.Webhook.custom-field.label": "增加自定义数据",
  "Webhook.common.Webhook.endpoint.label": "URL",
  "Webhook.common.Webhook.endpoint.placeholder": "请填写URL",
  "Webhook.common.Webhook.endpoint.validateError": "请输入https开头的有效网址",
  "Webhook.common.Webhook.event.label": "事件类型",
  "Webhook.common.Webhook.event.placeholder": "请选择事件类型",
  "Webhook.common.Webhook.secret.label": "密钥",
  "Webhook.common.Webhook.secret.placeholder": "请填写密钥",
  "Webhook.common.Webhook.secret.validateError": "请输入长度为32位的字符串",
  "Webhook.common.Webhook.topic.label": "Webhook名称",
  "Webhook.common.Webhook.topic.placeholder": "请输入Webhook名称",
  "Webhook.title": "设置",
}
